function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function e(e, t) {
  var _n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
  if (!_n) {
    if (Array.isArray(e) || (_n = r(e)) || t && e && "number" == typeof e.length) {
      _n && (e = _n);
      var i = 0,
        s = function s() {};
      return {
        s: s,
        n: function n() {
          return i >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[i++]
          };
        },
        e: function e(_e2) {
          throw _e2;
        },
        f: s
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    c = !1;
  return {
    s: function s() {
      _n = _n.call(e);
    },
    n: function n() {
      var e = _n.next();
      return a = e.done, e;
    },
    e: function e(_e3) {
      c = !0, o = _e3;
    },
    f: function f() {
      try {
        a || null == _n["return"] || _n["return"]();
      } finally {
        if (c) throw o;
      }
    }
  };
}
function t(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != r) {
      var n,
        i,
        s,
        o,
        a = [],
        c = !0,
        u = !1;
      try {
        if (s = (r = r.call(e)).next, 0 === t) {
          if (Object(r) !== r) return;
          c = !1;
        } else for (; !(c = (n = s.call(r)).done) && (a.push(n.value), a.length !== t); c = !0);
      } catch (e) {
        u = !0, i = e;
      } finally {
        try {
          if (!c && null != r["return"] && (o = r["return"](), Object(o) !== o)) return;
        } finally {
          if (u) throw i;
        }
      }
      return a;
    }
  }(e, t) || r(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function r(e, t) {
  if (e) {
    if ("string" == typeof e) return n(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? n(e, t) : void 0;
  }
}
function n(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function i(e) {
  return i = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
    return _typeof(e);
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
  }, i(e);
}
function s() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  s = function s() {
    return t;
  };
  var e,
    t = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (e, t, r) {
      e[t] = r.value;
    },
    a = "function" == typeof Symbol ? Symbol : {},
    c = a.iterator || "@@iterator",
    u = a.asyncIterator || "@@asyncIterator",
    l = a.toStringTag || "@@toStringTag";
  function d(e, t, r) {
    return Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), e[t];
  }
  try {
    d({}, "");
  } catch (e) {
    d = function d(e, t, r) {
      return e[t] = r;
    };
  }
  function h(e, t, r, n) {
    var i = t && t.prototype instanceof g ? t : g,
      s = Object.create(i.prototype),
      a = new D(n || []);
    return o(s, "_invoke", {
      value: E(e, r, a)
    }), s;
  }
  function p(e, t, r) {
    try {
      return {
        type: "normal",
        arg: e.call(t, r)
      };
    } catch (e) {
      return {
        type: "throw",
        arg: e
      };
    }
  }
  t.wrap = h;
  var f = "suspendedStart",
    _ = "suspendedYield",
    m = "executing",
    v = "completed",
    y = {};
  function g() {}
  function b() {}
  function k() {}
  var w = {};
  d(w, c, function () {
    return this;
  });
  var S = Object.getPrototypeOf,
    C = S && S(S(I([])));
  C && C !== r && n.call(C, c) && (w = C);
  var A = k.prototype = g.prototype = Object.create(w);
  function T(e) {
    ["next", "throw", "return"].forEach(function (t) {
      d(e, t, function (e) {
        return this._invoke(t, e);
      });
    });
  }
  function O(e, t) {
    function r(s, o, a, c) {
      var u = p(e[s], e, o);
      if ("throw" !== u.type) {
        var l = u.arg,
          d = l.value;
        return d && "object" == i(d) && n.call(d, "__await") ? t.resolve(d.__await).then(function (e) {
          r("next", e, a, c);
        }, function (e) {
          r("throw", e, a, c);
        }) : t.resolve(d).then(function (e) {
          l.value = e, a(l);
        }, function (e) {
          return r("throw", e, a, c);
        });
      }
      c(u.arg);
    }
    var s;
    o(this, "_invoke", {
      value: function value(e, n) {
        function i() {
          return new t(function (t, i) {
            r(e, n, t, i);
          });
        }
        return s = s ? s.then(i, i) : i();
      }
    });
  }
  function E(t, r, n) {
    var i = f;
    return function (s, o) {
      if (i === m) throw new Error("Generator is already running");
      if (i === v) {
        if ("throw" === s) throw o;
        return {
          value: e,
          done: !0
        };
      }
      for (n.method = s, n.arg = o;;) {
        var a = n.delegate;
        if (a) {
          var c = P(a, n);
          if (c) {
            if (c === y) continue;
            return c;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (i === f) throw i = v, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        i = m;
        var u = p(t, r, n);
        if ("normal" === u.type) {
          if (i = n.done ? v : _, u.arg === y) continue;
          return {
            value: u.arg,
            done: n.done
          };
        }
        "throw" === u.type && (i = v, n.method = "throw", n.arg = u.arg);
      }
    };
  }
  function P(t, r) {
    var n = r.method,
      i = t.iterator[n];
    if (i === e) return r.delegate = null, "throw" === n && t.iterator["return"] && (r.method = "return", r.arg = e, P(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var s = p(i, t.iterator, r.arg);
    if ("throw" === s.type) return r.method = "throw", r.arg = s.arg, r.delegate = null, y;
    var o = s.arg;
    return o ? o.done ? (r[t.resultName] = o.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e), r.delegate = null, y) : o : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function x(e) {
    var t = {
      tryLoc: e[0]
    };
    1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
  }
  function R(e) {
    var t = e.completion || {};
    t.type = "normal", delete t.arg, e.completion = t;
  }
  function D(e) {
    this.tryEntries = [{
      tryLoc: "root"
    }], e.forEach(x, this), this.reset(!0);
  }
  function I(t) {
    if (t || "" === t) {
      var r = t[c];
      if (r) return r.call(t);
      if ("function" == typeof t.next) return t;
      if (!isNaN(t.length)) {
        var s = -1,
          o = function r() {
            for (; ++s < t.length;) if (n.call(t, s)) return r.value = t[s], r.done = !1, r;
            return r.value = e, r.done = !0, r;
          };
        return o.next = o;
      }
    }
    throw new TypeError(i(t) + " is not iterable");
  }
  return b.prototype = k, o(A, "constructor", {
    value: k,
    configurable: !0
  }), o(k, "constructor", {
    value: b,
    configurable: !0
  }), b.displayName = d(k, l, "GeneratorFunction"), t.isGeneratorFunction = function (e) {
    var t = "function" == typeof e && e.constructor;
    return !!t && (t === b || "GeneratorFunction" === (t.displayName || t.name));
  }, t.mark = function (e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, k) : (e.__proto__ = k, d(e, l, "GeneratorFunction")), e.prototype = Object.create(A), e;
  }, t.awrap = function (e) {
    return {
      __await: e
    };
  }, T(O.prototype), d(O.prototype, u, function () {
    return this;
  }), t.AsyncIterator = O, t.async = function (e, r, n, i, s) {
    void 0 === s && (s = Promise);
    var o = new O(h(e, r, n, i), s);
    return t.isGeneratorFunction(r) ? o : o.next().then(function (e) {
      return e.done ? e.value : o.next();
    });
  }, T(A), d(A, l, "Generator"), d(A, c, function () {
    return this;
  }), d(A, "toString", function () {
    return "[object Generator]";
  }), t.keys = function (e) {
    var t = Object(e),
      r = [];
    for (var n in t) r.push(n);
    return r.reverse(), function e() {
      for (; r.length;) {
        var n = r.pop();
        if (n in t) return e.value = n, e.done = !1, e;
      }
      return e.done = !0, e;
    };
  }, t.values = I, D.prototype = {
    constructor: D,
    reset: function reset(t) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(R), !t) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e);
    },
    stop: function stop() {
      this.done = !0;
      var e = this.tryEntries[0].completion;
      if ("throw" === e.type) throw e.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(t) {
      if (this.done) throw t;
      var r = this;
      function i(n, i) {
        return a.type = "throw", a.arg = t, r.next = n, i && (r.method = "next", r.arg = e), !!i;
      }
      for (var s = this.tryEntries.length - 1; s >= 0; --s) {
        var o = this.tryEntries[s],
          a = o.completion;
        if ("root" === o.tryLoc) return i("end");
        if (o.tryLoc <= this.prev) {
          var c = n.call(o, "catchLoc"),
            u = n.call(o, "finallyLoc");
          if (c && u) {
            if (this.prev < o.catchLoc) return i(o.catchLoc, !0);
            if (this.prev < o.finallyLoc) return i(o.finallyLoc);
          } else if (c) {
            if (this.prev < o.catchLoc) return i(o.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < o.finallyLoc) return i(o.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(e, t) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var i = this.tryEntries[r];
        if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
          var s = i;
          break;
        }
      }
      s && ("break" === e || "continue" === e) && s.tryLoc <= t && t <= s.finallyLoc && (s = null);
      var o = s ? s.completion : {};
      return o.type = e, o.arg = t, s ? (this.method = "next", this.next = s.finallyLoc, y) : this.complete(o);
    },
    complete: function complete(e, t) {
      if ("throw" === e.type) throw e.arg;
      return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), y;
    },
    finish: function finish(e) {
      for (var t = this.tryEntries.length - 1; t >= 0; --t) {
        var r = this.tryEntries[t];
        if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), R(r), y;
      }
    },
    "catch": function _catch(e) {
      for (var t = this.tryEntries.length - 1; t >= 0; --t) {
        var r = this.tryEntries[t];
        if (r.tryLoc === e) {
          var n = r.completion;
          if ("throw" === n.type) {
            var i = n.arg;
            R(r);
          }
          return i;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(t, r, n) {
      return this.delegate = {
        iterator: I(t),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = e), y;
    }
  }, t;
}
function o(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (s = n.key, o = void 0, o = function (e, t) {
      if ("object" !== i(e) || null === e) return e;
      var r = e[Symbol.toPrimitive];
      if (void 0 !== r) {
        var n = r.call(e, t || "default");
        if ("object" !== i(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(s, "string"), "symbol" === i(o) ? o : String(o)), n);
  }
  var s, o;
}
function a(e, t, r) {
  return t && o(e.prototype, t), r && o(e, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function c(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function u(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && _(e, t);
}
function l(e) {
  var t = f();
  return function () {
    var r,
      n = m(e);
    if (t) {
      var s = m(this).constructor;
      r = Reflect.construct(n, arguments, s);
    } else r = n.apply(this, arguments);
    return function (e, t) {
      if (t && ("object" === i(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return d(e);
    }(this, r);
  };
}
function d(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function h(e) {
  var t = "function" == typeof Map ? new Map() : void 0;
  return h = function h(e) {
    if (null === e || (r = e, -1 === Function.toString.call(r).indexOf("[native code]"))) return e;
    var r;
    if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== t) {
      if (t.has(e)) return t.get(e);
      t.set(e, n);
    }
    function n() {
      return p(e, arguments, m(this).constructor);
    }
    return n.prototype = Object.create(e.prototype, {
      constructor: {
        value: n,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _(n, e);
  }, h(e);
}
function p(e, t, r) {
  return p = f() ? Reflect.construct.bind() : function (e, t, r) {
    var n = [null];
    n.push.apply(n, t);
    var i = new (Function.bind.apply(e, n))();
    return r && _(i, r.prototype), i;
  }, p.apply(null, arguments);
}
function f() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}
function _(e, t) {
  return _ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, _(e, t);
}
function m(e) {
  return m = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, m(e);
}
var v,
  y,
  g,
  b,
  k,
  w,
  S = "https://accounts.google.com/gsi",
  C = "".concat(S, "/client");
function A(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var i = 0;
    for (n = Object.getOwnPropertySymbols(e); i < n.length; i++) t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
  }
  return r;
}
function T(e, t, r, n) {
  return new (r || (r = Promise))(function (i, s) {
    function o(e) {
      try {
        c(n.next(e));
      } catch (e) {
        s(e);
      }
    }
    function a(e) {
      try {
        c(n["throw"](e));
      } catch (e) {
        s(e);
      }
    }
    function c(e) {
      var t;
      e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
        e(t);
      })).then(o, a);
    }
    c((n = n.apply(e, t || [])).next());
  });
}
"function" == typeof SuppressedError && SuppressedError, function (e) {
  e.emailMagicLinks = "emailMagicLinks", e.oauth = "oauth", e.otp = "otp", e.crypto = "crypto", e.passwords = "passwords", e.passkeys = "passkeys";
}(v || (v = {})), function (e) {
  e.Google = "google", e.Microsoft = "microsoft", e.Apple = "apple", e.Github = "github", e.GitLab = "gitlab", e.Facebook = "facebook", e.Discord = "discord", e.Salesforce = "salesforce", e.Slack = "slack", e.Amazon = "amazon", e.Bitbucket = "bitbucket", e.LinkedIn = "linkedin", e.Coinbase = "coinbase", e.Twitch = "twitch", e.Twitter = "twitter", e.TikTok = "tiktok", e.Snapchat = "snapchat", e.Figma = "figma", e.Yahoo = "yahoo";
}(y || (y = {})), function (e) {
  e.Vessel = "Vessel", e.Phantom = "Phantom", e.Metamask = "Metamask", e.Coinbase = "Coinbase", e.Binance = "Binance", e.GenericEthereumWallet = "Other Ethereum Wallet", e.GenericSolanaWallet = "Other Solana Wallet";
}(g || (g = {})), function (e) {
  e.embedded = "embedded", e.floating = "floating";
}(b || (b = {})), function (e) {
  e.SMS = "sms", e.WhatsApp = "whatsapp", e.Email = "email";
}(k || (k = {})), function (e) {
  e.MagicLinkLoginOrCreateEvent = "MAGIC_LINK_LOGIN_OR_CREATE", e.OTPsLoginOrCreateEvent = "OTP_LOGIN_OR_CREATE", e.OTPsAuthenticate = "OTP_AUTHENTICATE", e.CryptoWalletAuthenticateStart = "CRYPTO_WALLET_AUTHENTICATE_START", e.CryptoWalletAuthenticate = "CRYPTO_WALLET_AUTHENTICATE", e.PasswordCreate = "PASSWORD_CREATE", e.PasswordAuthenticate = "PASSWORD_AUTHENTICATE", e.PasswordResetByEmailStart = "PASSWORD_RESET_BY_EMAIL_START", e.PasswordResetByEmail = "PASSWORD_RESET_BY_EMAIL", e.PasskeyRegister = "PASSKEY_REGISTER", e.PasskeyAuthenticate = "PASSKEY_AUTHENTICATE", e.PasskeySkip = "PASSKEY_SKIP", e.PasskeyDone = "PASSKEY_DONE", e.B2BMagicLinkEmailLoginOrSignup = "B2B_MAGIC_LINK_EMAIL_LOGIN_OR_SIGNUP", e.B2BMagicLinkAuthenticate = "B2B_MAGIC_LINK_AUTHENTICATE", e.B2BMagicLinkEmailDiscoverySend = "B2B_MAGIC_LINK_EMAIL_DISCOVERY_SEND", e.B2BMagicLinkDiscoveryAuthenticate = "B2B_MAGIC_LINK_DISCOVERY_AUTHENTICATE", e.B2BSSOStart = "B2B_SSO_START", e.B2BSSOAuthenticate = "B2B_SSO_AUTHENTICATE", e.B2BOAuthAuthenticate = "B2B_SSO_AUTHENTICATE", e.B2BOAuthDiscoveryAuthenticate = "B2B_OAUTH_DISCOVERY_AUTHENTICATE", e.B2BDiscoveryOrganizationsCreate = "B2B_DISCOVERY_ORGANIZATIONS_CREATE", e.B2BDiscoveryIntermediateSessionExchange = "B2B_DISCOVERY_INTERMEDIATE_SESSION_EXCHANGE", e.B2BPasswordAuthenticate = "B2B_PASSWORD_AUTHENTICATE", e.B2BPasswordResetByEmailStart = "B2B_PASSWORD_RESET_BY_EMAIL_START", e.B2BPasswordResetByEmail = "B2B_PASSWORD_RESET_BY_EMAIL", e.B2BPasswordResetBySession = "B2B_PASSWORD_RESET_BY_SESSION";
}(w || (w = {}));
var O,
  E,
  P,
  x,
  R,
  D = function (e) {
    u(r, h(Error));
    var t = l(r);
    function r(e, n) {
      var i;
      return c(this, r), (i = t.call(this, e + "\n" + n)).message = e + "\n" + n, i.name = "SDKAPIUnreachableError", i.details = n, Object.setPrototypeOf(d(i), r.prototype), i;
    }
    return a(r);
  }(),
  I = function (e) {
    u(r, h(Error));
    var t = l(r);
    function r(e, n) {
      var i;
      return c(this, r), (i = t.call(this)).name = "StytchSDKUsageError", i.message = "Invalid call to ".concat(e, "\n") + n, i;
    }
    return a(r);
  }(),
  B = function (e) {
    u(r, h(Error));
    var t = l(r);
    function r(e) {
      var n, i;
      c(this, r), (n = t.call(this)).name = "StytchSDKSchemaError";
      var s = null === (i = e.body) || void 0 === i ? void 0 : i.map(function (e) {
        return "".concat(e.dataPath, ": ").concat(e.message);
      }).join("\n");
      return n.message = "[400] Request does not match expected schema\n".concat(s), n;
    }
    return a(r);
  }(),
  L = function (e) {
    u(r, h(Error));
    var t = l(r);
    function r(e) {
      var n;
      c(this, r), (n = t.call(this)).name = "StytchSDKAPIError";
      var i = e.status_code,
        s = e.error_type,
        o = e.error_message,
        a = e.error_url,
        u = e.request_id;
      return n.error_type = s, n.error_message = o, n.error_url = a, n.request_id = u, n.status_code = i, n.message = "[".concat(i, "] ").concat(s, "\n") + "".concat(o, "\n") + "See ".concat(a, " for more information.\n") + (u ? "request_id: ".concat(u, "\n") : ""), n;
    }
    return a(r);
  }(),
  F = ["unauthorized_credentials", "user_unauthenticated", "invalid_secret_authentication", "session_not_found"];
!function (e) {
  e.BiometricsSensorError = "biometrics_sensor_error", e.DeviceCredentialsNotAllowed = "device_credentials_not_allowed", e.DeviceHardwareError = "device_hardware_error", e.InternalError = "internal_error", e.KeyInvalidated = "key_invalidated", e.KeystoreUnavailable = "keystore_unavailable", e.NoBiometricsEnrolled = "no_biometrics_enrolled", e.NoBiometricsRegistration = "no_biometrics_registration", e.SessionExpired = "session_expired", e.UserCancellation = "user_cancellation", e.UserLockedOut = "user_locked_out", e.BiometricsNotAvailable = "biometrics_not_available";
}(O || (O = {})), function (e) {
  e.emailMagicLinks = "emailMagicLinks", e.sso = "sso", e.passwords = "passwords", e.oauth = "oauth";
}(E || (E = {})), function (e) {
  e.Discovery = "Discovery", e.Organization = "Organization", e.PasswordReset = "PasswordReset";
}(P || (P = {})), function (e) {
  e.Google = "google", e.Microsoft = "microsoft";
}(x || (x = {})), function (e) {
  e.RequiredCatcha = "Catcha Required";
}(R || (R = {}));
var j,
  M = function (e) {
    u(r, h(Error));
    var t = l(r);
    function r(e) {
      var n;
      return c(this, r), (n = t.call(this, e)).type = e, n;
    }
    return a(r);
  }();
function N(e) {
  var t = e.method,
    r = e.errorMessage,
    n = e.finalURL,
    i = e.basicAuthHeader,
    o = e.xSDKClientHeader,
    a = e.xSDKParentHostHeader,
    c = e.body;
  return T(this, void 0, void 0, s().mark(function e() {
    var u, l, d, h, p, f;
    return s().wrap(function (e) {
      for (;;) switch (e.prev = e.next) {
        case 0:
          return u = {
            Authorization: i,
            "Content-Type": "application/json",
            "X-SDK-Client": o
          }, a && (u["X-SDK-Parent-Host"] = a), l = {
            method: t,
            headers: u,
            body: c && JSON.stringify(c)
          }, e.prev = 3, e.next = 6, fetch(n, l);
        case 6:
          d = e.sent, e.next = 14;
          break;
        case 9:
          if (e.prev = 9, e.t0 = e["catch"](3), "Failed to fetch" !== e.t0.message) {
            e.next = 13;
            break;
          }
          throw new D(r, "Unable to contact the Stytch servers. Are you online?");
        case 13:
          throw e.t0;
        case 14:
          if (403 !== d.status) {
            e.next = 27;
            break;
          }
          return e.prev = 15, e.next = 18, d.text();
        case 18:
          h = e.sent, e.next = 24;
          break;
        case 21:
          throw e.prev = 21, e.t1 = e["catch"](15), new D(r, "Invalid response from the Stytch servers.");
        case 24:
          if (!h.includes("Captcha required")) {
            e.next = 26;
            break;
          }
          throw new M(R.RequiredCatcha);
        case 26:
          throw new D(r, "Invalid response from the Stytch servers.");
        case 27:
          if (200 === d.status) {
            e.next = 40;
            break;
          }
          return e.prev = 28, e.next = 31, d.json();
        case 31:
          p = e.sent, e.next = 37;
          break;
        case 34:
          throw e.prev = 34, e.t2 = e["catch"](28), new D(r, "Invalid or no response from server");
        case 37:
          if (!("body" in p || "params" in p || "query" in p)) {
            e.next = 39;
            break;
          }
          throw new B(p);
        case 39:
          throw new L(p);
        case 40:
          return e.prev = 40, e.next = 43, d.json();
        case 43:
          return f = e.sent, e.abrupt("return", f.data);
        case 47:
          throw e.prev = 47, e.t3 = e["catch"](40), new D(r, "Invalid response from the Stytch servers.");
        case 50:
        case "end":
          return e.stop();
      }
    }, e, null, [[3, 9], [15, 21], [28, 34], [40, 47]]);
  }));
}
var U = new Uint8Array(16);
function K() {
  if (!j && !(j = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto))) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return j(U);
}
var W = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
for (var q = [], G = 0; G < 256; ++G) q.push((G + 256).toString(16).substr(1));
function H(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
    r = (q[e[t + 0]] + q[e[t + 1]] + q[e[t + 2]] + q[e[t + 3]] + "-" + q[e[t + 4]] + q[e[t + 5]] + "-" + q[e[t + 6]] + q[e[t + 7]] + "-" + q[e[t + 8]] + q[e[t + 9]] + "-" + q[e[t + 10]] + q[e[t + 11]] + q[e[t + 12]] + q[e[t + 13]] + q[e[t + 14]] + q[e[t + 15]]).toLowerCase();
  if (!function (e) {
    return "string" == typeof e && W.test(e);
  }(r)) throw TypeError("Stringified UUID is invalid");
  return r;
}
function Y(e, t, r) {
  var n = (e = e || {}).random || (e.rng || K)();
  if (n[6] = 15 & n[6] | 64, n[8] = 63 & n[8] | 128, t) {
    r = r || 0;
    for (var i = 0; i < 16; ++i) t[r + i] = n[i];
    return t;
  }
  return H(n);
}
var z = {};
function V(e, t) {
  return T(this, void 0, void 0, s().mark(function r() {
    return s().wrap(function (r) {
      for (;;) switch (r.prev = r.next) {
        case 0:
          if (void 0 === z[e]) {
            r.next = 2;
            break;
          }
          return r.abrupt("return", z[e]);
        case 2:
          return z[e] = J(e, t), r.abrupt("return", z[e]);
        case 4:
        case "end":
          return r.stop();
      }
    }, r);
  }));
}
function J(e, t) {
  return new Promise(function (r, n) {
    var i = function (e) {
      var t = $(e);
      if (t[0]) return t[0];
    }(e);
    if (i && "true" === i.dataset.loaded) try {
      r(t());
    } catch (t) {
      return n(new Error("".concat(e, " already loaded, but module was not found in global scope: ").concat(t)));
    }
    var s = function (e) {
      var t = document.createElement("script");
      return t.setAttribute("src", e), t.setAttribute("async", "true"), t.setAttribute("defer", "true"), document.head.appendChild(t), t;
    }(e);
    s.addEventListener("load", function () {
      s.dataset.loaded = "true";
      try {
        r(t());
      } catch (t) {
        n(new Error("".concat(e, " was loaded, but module was not found in global scope: ").concat(t)));
      }
    }), s.addEventListener("error", function (t) {
      n(new Error("".concat(e, " could not be loaded: ").concat(t)));
    });
  });
}
var $ = function $(e) {
  return document.querySelectorAll('script[src="'.concat(e, '"]'));
};
var X,
  Z = ["[Stytch]"],
  Q = function Q() {
    for (var e, t = arguments.length, r = new Array(t), n = 0; n < t; n++) r[n] = arguments[n];
    return (e = console).warn.apply(e, Z.concat(r));
  },
  ee = function ee() {
    for (var e, t = arguments.length, r = new Array(t), n = 0; n < t; n++) r[n] = arguments[n];
    return (e = console).error.apply(e, Z.concat(r));
  },
  te = "\nYou can find your public token at https://stytch.com/dashboard/api-keys.",
  re = function re(t) {
    var r = {
      isObject: function isObject(e, n) {
        var s = "object" === i(n) && !Array.isArray(n) && null !== n;
        if (!s) throw new I(t, e + " must be an object.");
        return r;
      },
      isOptionalObject: function isOptionalObject(e, t) {
        return void 0 === t ? r : r.isObject(e, t);
      },
      isString: function isString(e, n) {
        if ("string" != typeof n) throw new I(t, e + " must be a string.");
        return r;
      },
      isOptionalString: function isOptionalString(e, t) {
        return void 0 === t ? r : r.isString(e, t);
      },
      isStringArray: function isStringArray(n, i) {
        if (!Array.isArray(i)) throw new I(t, n + " must be an array of strings.");
        var s,
          o = e(i);
        try {
          for (o.s(); !(s = o.n()).done;) {
            if ("string" != typeof s.value) throw new I(t, n + " must be an array of strings.");
          }
        } catch (e) {
          o.e(e);
        } finally {
          o.f();
        }
        return r;
      },
      isOptionalStringArray: function isOptionalStringArray(e, t) {
        return void 0 === t ? r : r.isStringArray(e, t);
      },
      isNumber: function isNumber(e, n) {
        if ("number" != typeof n) throw new I(t, e + " must be a number.");
        return r;
      },
      isOptionalNumber: function isOptionalNumber(e, t) {
        return void 0 === t ? r : r.isNumber(e, t);
      },
      isBoolean: function isBoolean(e, n) {
        if ("boolean" != typeof n) throw new I(t, e + " must be a boolean.");
        return r;
      },
      isOptionalBoolean: function isOptionalBoolean(e, t) {
        return void 0 === t ? r : r.isBoolean(e, t);
      }
    };
    return r;
  },
  ne = function ne(e) {
    return A(e, ["request_id", "status_code"]);
  },
  ie = function ie(e) {
    return A(e, ["__user"]);
  },
  se = a(function e(t, r, n) {
    var i = this,
      o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : function () {
        return Promise.resolve(void 0);
      };
    c(this, e), this.bootstrapPromise = n, this.isEnabled = function () {
      return T(i, void 0, void 0, s().mark(function e() {
        return s().wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", this.state.then(function (e) {
                return e.enabled;
              }));
            case 1:
            case "end":
              return e.stop();
          }
        }, e, this);
      }));
    }, this.getTelemetryID = function () {
      return T(i, void 0, void 0, s().mark(function e() {
        var t, r, n, i;
        return s().wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this.state;
            case 2:
              if (t = e.sent, r = t.publicToken, n = t.enabled, i = t.dfpBackendURL, n) {
                e.next = 8;
                break;
              }
              return e.abrupt("return", void 0);
            case 8:
              return e.next = 10, window.GetTelemetryID(r, "".concat(i, "/submit"));
            case 10:
              return e.abrupt("return", e.sent);
            case 11:
            case "end":
              return e.stop();
          }
        }, e, this);
      }));
    }, this.getDFPTelemetryIDAndCaptcha = function () {
      return T(i, void 0, void 0, s().mark(function e() {
        var t, r, n, i, o, a;
        return s().wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this.state;
            case 2:
              if (t = e.sent, r = t.enabled, n = t.executeRecaptcha, i = t.mode, o = void 0, a = void 0, r) {
                e.next = 12;
                break;
              }
              return e.next = 11, n();
            case 11:
              a = e.sent;
            case 12:
              if ("DECISIONING" !== i) {
                e.next = 18;
                break;
              }
              return e.next = 15, this.getTelemetryID();
            case 15:
              o = e.sent, e.next = 25;
              break;
            case 18:
              if ("OBSERVATION" !== i) {
                e.next = 25;
                break;
              }
              return e.next = 21, this.getTelemetryID();
            case 21:
              return o = e.sent, e.next = 24, n();
            case 24:
              a = e.sent;
            case 25:
              return e.abrupt("return", {
                dfp_telemetry_id: o,
                captcha_token: a
              });
            case 26:
            case "end":
              return e.stop();
          }
        }, e, this);
      }));
    }, this.retryWithCaptchaAndDFP = function (e, t) {
      return T(i, void 0, void 0, s().mark(function r() {
        var n, i, o;
        return s().wrap(function (r) {
          for (;;) switch (r.prev = r.next) {
            case 0:
              return r.next = 2, this.state;
            case 2:
              if (n = r.sent, i = n.enabled, o = n.executeRecaptcha, e.type !== R.RequiredCatcha || !i) {
                r.next = 14;
                break;
              }
              if (!t.body) {
                r.next = 13;
                break;
              }
              return r.next = 9, this.getTelemetryID();
            case 9:
              return t.body.dfp_telemetry_id = r.sent, r.next = 12, o();
            case 12:
              t.body.captcha_token = r.sent;
            case 13:
              return r.abrupt("return", t);
            case 14:
              throw new Error("Unable to query captcha and/or dfp telemetry ID");
            case 15:
            case "end":
              return r.stop();
          }
        }, r, this);
      }));
    }, this.state = n.then(function (e) {
      return T(i, void 0, void 0, s().mark(function n() {
        return s().wrap(function (n) {
          for (;;) switch (n.prev = n.next) {
            case 0:
              if (e.runDFPProtectedAuth) {
                n.next = 2;
                break;
              }
              return n.abrupt("return", {
                publicToken: t,
                dfpBackendURL: r,
                enabled: !1,
                loaded: !1,
                executeRecaptcha: o
              });
            case 2:
              return n.next = 4, void V("".concat("https://elements.stytch.com", "/telemetry.js"), function () {
                return window;
              });
            case 4:
              return n.abrupt("return", {
                publicToken: t,
                dfpBackendURL: r,
                enabled: !0,
                mode: e.dfpProtectedAuthMode || "OBSERVATION",
                loaded: !0,
                executeRecaptcha: o
              });
            case 5:
            case "end":
              return n.stop();
          }
        }, n);
      }));
    });
  }),
  oe = function oe() {
    return {
      isEnabled: function isEnabled() {
        return T(void 0, void 0, void 0, s().mark(function e() {
          return s().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", !1);
              case 1:
              case "end":
                return e.stop();
            }
          }, e);
        }));
      },
      getTelemetryID: function getTelemetryID() {
        return T(void 0, void 0, void 0, s().mark(function e() {
          return s().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", void 0);
              case 1:
              case "end":
                return e.stop();
            }
          }, e);
        }));
      },
      getDFPTelemetryIDAndCaptcha: function getDFPTelemetryIDAndCaptcha() {
        return T(void 0, void 0, void 0, s().mark(function e() {
          return s().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", {
                  dfp_telemetry_id: void 0,
                  captcha_token: void 0
                });
              case 1:
              case "end":
                return e.stop();
            }
          }, e);
        }));
      },
      retryWithCaptchaAndDFP: function retryWithCaptchaAndDFP() {
        return T(void 0, void 0, void 0, s().mark(function e() {
          return s().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                throw new Error("DFP protected auth is disabled");
              case 1:
              case "end":
                return e.stop();
            }
          }, e);
        }));
      }
    };
  },
  ae = function () {
    function e() {
      c(this, e);
    }
    return a(e, null, [{
      key: "marshall",
      value: function value(e) {
        return Object.assign(Object.assign({}, e), {
          name: e.name,
          message: e.message,
          stack: e.stack
        });
      }
    }, {
      key: "inflate",
      value: function value(e, t) {
        var r = new e(t);
        return Object.assign(r, t), Object.setPrototypeOf(r, e.prototype), r;
      }
    }, {
      key: "unmarshall",
      value: function value(t) {
        if ("name" in t) switch (t.name) {
          case "SDKAPIUnreachableError":
            return e.inflate(D, t);
          case "StytchSDKSchemaError":
            return e.inflate(B, t);
          case "StytchSDKAPIError":
            return e.inflate(L, t);
          case "TypeError":
            return e.inflate(TypeError, t);
          case "SyntaxError":
            return e.inflate(SyntaxError, t);
          case "ReferenceError":
            return e.inflate(ReferenceError, t);
          case "RangeError":
            return e.inflate(RangeError, t);
          case "EvalError":
            return e.inflate(EvalError, t);
          case "URIError":
            return e.inflate(URIError, t);
        }
        return e.inflate(Error, t);
      }
    }]), e;
  }(),
  ce = function () {
    function e(t) {
      c(this, e), this.maxBatchSize = t.maxBatchSize, this.logEventURL = t.logEventURL, setInterval(this.flush.bind(this), t.intervalDurationMs), this.batch = [];
    }
    return a(e, [{
      key: "logEvent",
      value: function value(e, t) {
        this.batch.push({
          telemetry: e,
          event: t
        }), this.batch.length >= this.maxBatchSize && this.flush();
      }
    }, {
      key: "flush",
      value: function value() {
        return T(this, void 0, void 0, s().mark(function e() {
          var t;
          return s().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (this.batch.length) {
                  e.next = 2;
                  break;
                }
                return e.abrupt("return");
              case 2:
                return t = this.batch, this.batch = [], e.prev = 4, e.next = 7, fetch(this.logEventURL, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json"
                  },
                  body: JSON.stringify(t)
                });
              case 7:
                e.next = 11;
                break;
              case 9:
                e.prev = 9, e.t0 = e["catch"](4);
              case 11:
              case "end":
                return e.stop();
            }
          }, e, this, [[4, 9]]);
        }));
      }
    }]), e;
  }();
!function (e) {
  e.LoginOrCreateEML = "login_or_create_eml", e.LoginOrCreateOTP = "login_or_create_otp", e.ResetPassword = "reset_password";
}(X || (X = {}));
var ue = a(function e(t, r) {
    var n = this;
    c(this, e), this._networkClient = t, this._subscriptionService = r, this.get = function () {
      return T(n, void 0, void 0, s().mark(function e() {
        var t, r;
        return s().wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this._networkClient.fetchSDK({
                url: "/users/me",
                errorMessage: "Failed to retrieve user info.",
                method: "GET"
              });
            case 2:
              return t = e.sent, r = ne(t), this._subscriptionService.updateUser(r), e.abrupt("return", r);
            case 6:
            case "end":
              return e.stop();
          }
        }, e, this);
      }));
    }, this.getSync = function () {
      return n._subscriptionService.getUser();
    }, this.update = function (e) {
      return T(n, void 0, void 0, s().mark(function t() {
        var r, n;
        return s().wrap(function (t) {
          for (;;) switch (t.prev = t.next) {
            case 0:
              return re("stytch.user.update").isOptionalObject("untrusted_metadata", e.untrusted_metadata), t.next = 3, this._networkClient.fetchSDK({
                url: "/users/me",
                body: e,
                errorMessage: "Failed to update user.",
                method: "PUT"
              });
            case 3:
              return r = t.sent, n = ne(r.__user), this._subscriptionService.updateUser(n), t.abrupt("return", ie(r));
            case 7:
            case "end":
              return t.stop();
          }
        }, t, this);
      }));
    }, this.deleteEmail = function (e) {
      return T(n, void 0, void 0, s().mark(function t() {
        var r, n;
        return s().wrap(function (t) {
          for (;;) switch (t.prev = t.next) {
            case 0:
              return t.next = 2, this._networkClient.fetchSDK({
                url: "/users/emails/".concat(e),
                errorMessage: "Failed to delete email.",
                method: "DELETE"
              });
            case 2:
              return r = t.sent, n = ne(r.__user), this._subscriptionService.updateUser(n), t.abrupt("return", ie(r));
            case 6:
            case "end":
              return t.stop();
          }
        }, t, this);
      }));
    }, this.deletePhoneNumber = function (e) {
      return T(n, void 0, void 0, s().mark(function t() {
        var r, n;
        return s().wrap(function (t) {
          for (;;) switch (t.prev = t.next) {
            case 0:
              return t.next = 2, this._networkClient.fetchSDK({
                url: "/users/phone_numbers/".concat(e),
                errorMessage: "Failed to delete phone number.",
                method: "DELETE"
              });
            case 2:
              return r = t.sent, n = ne(r.__user), this._subscriptionService.updateUser(n), t.abrupt("return", ie(r));
            case 6:
            case "end":
              return t.stop();
          }
        }, t, this);
      }));
    }, this.deleteTOTP = function (e) {
      return T(n, void 0, void 0, s().mark(function t() {
        var r, n;
        return s().wrap(function (t) {
          for (;;) switch (t.prev = t.next) {
            case 0:
              return t.next = 2, this._networkClient.fetchSDK({
                url: "/users/totps/".concat(e),
                errorMessage: "Failed to delete TOTP.",
                method: "DELETE"
              });
            case 2:
              return r = t.sent, n = ne(r.__user), this._subscriptionService.updateUser(n), t.abrupt("return", ie(r));
            case 6:
            case "end":
              return t.stop();
          }
        }, t, this);
      }));
    }, this.deleteOAuthRegistration = function (e) {
      return T(n, void 0, void 0, s().mark(function t() {
        var r, n;
        return s().wrap(function (t) {
          for (;;) switch (t.prev = t.next) {
            case 0:
              return t.next = 2, this._networkClient.fetchSDK({
                url: "/users/oauth/".concat(e),
                errorMessage: "Failed to delete OAuth registration.",
                method: "DELETE"
              });
            case 2:
              return r = t.sent, n = ne(r.__user), this._subscriptionService.updateUser(n), t.abrupt("return", ie(r));
            case 6:
            case "end":
              return t.stop();
          }
        }, t, this);
      }));
    }, this.deleteWebauthnRegistration = function (e) {
      return T(n, void 0, void 0, s().mark(function t() {
        var r, n;
        return s().wrap(function (t) {
          for (;;) switch (t.prev = t.next) {
            case 0:
              return t.next = 2, this._networkClient.fetchSDK({
                url: "/users/webauthn_registrations/".concat(e),
                errorMessage: "Failed to delete WebAuthn registration.",
                method: "DELETE"
              });
            case 2:
              return r = t.sent, n = ne(r.__user), this._subscriptionService.updateUser(n), t.abrupt("return", ie(r));
            case 6:
            case "end":
              return t.stop();
          }
        }, t, this);
      }));
    }, this.deleteBiometricRegistration = function (e) {
      return T(n, void 0, void 0, s().mark(function t() {
        var r, n;
        return s().wrap(function (t) {
          for (;;) switch (t.prev = t.next) {
            case 0:
              return t.next = 2, this._networkClient.fetchSDK({
                url: "/users/biometric_registrations/".concat(e),
                errorMessage: "Failed to delete Biometric registration.",
                method: "DELETE"
              });
            case 2:
              return r = t.sent, n = ne(r.__user), this._subscriptionService.updateUser(n), t.abrupt("return", ie(r));
            case 6:
            case "end":
              return t.stop();
          }
        }, t, this);
      }));
    }, this.onChange = function (e) {
      var t = n._subscriptionService.getUser();
      return n._subscriptionService.subscribeToState(function (r) {
        var n;
        (null == r ? void 0 : r.user) !== t && (t = null !== (n = null == r ? void 0 : r.user) && void 0 !== n ? n : null, e(t));
      });
    };
  }),
  le = function () {
    function e(t, r) {
      var n = this;
      c(this, e), this._networkClient = t, this._subscriptionService = r, this.getSync = function () {
        return n._subscriptionService.getSession();
      }, this.onChange = function (e) {
        var t = n._subscriptionService.getSession();
        return n._subscriptionService.subscribeToState(function (r) {
          var n;
          (null == r ? void 0 : r.session) !== t && (t = null !== (n = null == r ? void 0 : r.session) && void 0 !== n ? n : null, e(t));
        });
      }, this.revoke = function (e) {
        return T(n, void 0, void 0, s().mark(function t() {
          var r;
          return s().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return t.prev = 0, t.next = 3, this._networkClient.fetchSDK({
                  url: "/sessions/revoke",
                  errorMessage: "Error revoking session",
                  method: "POST"
                });
              case 3:
                return r = t.sent, this._subscriptionService.destroyState(), t.abrupt("return", r);
              case 8:
                throw t.prev = 8, t.t0 = t["catch"](0), ((null == e ? void 0 : e.forceClear) || F.includes(t.t0.error_type)) && this._subscriptionService.destroyState(), t.t0;
              case 12:
              case "end":
                return t.stop();
            }
          }, t, this, [[0, 8]]);
        }));
      }, this.authenticate = function (e) {
        return T(n, void 0, void 0, s().mark(function t() {
          var r, n;
          return s().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return t.prev = 0, r = {
                  session_duration_minutes: null == e ? void 0 : e.session_duration_minutes
                }, t.next = 4, this._networkClient.fetchSDK({
                  url: "/sessions/authenticate",
                  body: r,
                  errorMessage: "Error authenticating session",
                  method: "POST"
                });
              case 4:
                return n = t.sent, this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: n.session,
                    user: n.user
                  },
                  session_token: n.session_token,
                  session_jwt: n.session_jwt,
                  intermediate_session_token: null
                }), t.abrupt("return", ie(n));
              case 9:
                throw t.prev = 9, t.t0 = t["catch"](0), F.includes(t.t0.error_type) && this._subscriptionService.destroyState(), t.t0;
              case 13:
              case "end":
                return t.stop();
            }
          }, t, this, [[0, 9]]);
        }));
      };
    }
    return a(e, [{
      key: "getTokens",
      value: function value() {
        return this._subscriptionService.getTokens();
      }
    }, {
      key: "updateSession",
      value: function value(e) {
        this._subscriptionService.updateTokens(e);
      }
    }]), e;
  }(),
  de = Promise.resolve({
    pkceRequiredForEmailMagicLinks: !1
  }),
  he = function () {
    function e(t, r, n, i) {
      var o = this,
        a = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : de,
        u = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : oe();
      c(this, e), this._networkClient = t, this._subscriptionService = r, this._pkceManager = n, this._passwordResetPKCEManager = i, this._config = a, this.dfpProtectedAuth = u, this.email = {
        loginOrCreate: function loginOrCreate(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return T(o, void 0, void 0, s().mark(function r() {
            var n, i, o, a, c, u, l;
            return s().wrap(function (r) {
              for (;;) switch (r.prev = r.next) {
                case 0:
                  return r.next = 2, this._config;
                case 2:
                  if (n = r.sent, i = n.pkceRequiredForEmailMagicLinks, o = void 0, !i) {
                    r.next = 9;
                    break;
                  }
                  return r.next = 8, this.getCodeChallenge();
                case 8:
                  o = r.sent;
                case 9:
                  return r.next = 11, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
                case 11:
                  return a = r.sent, c = a.dfp_telemetry_id, u = a.captcha_token, l = Object.assign(Object.assign({}, t), {
                    email: e,
                    code_challenge: o,
                    captcha_token: u,
                    dfp_telemetry_id: c
                  }), r.abrupt("return", this._networkClient.retriableFetchSDK({
                    url: "/magic_links/email/login_or_create",
                    body: l,
                    errorMessage: "Failed to send magic link",
                    method: "POST",
                    retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                  }));
                case 16:
                case "end":
                  return r.stop();
              }
            }, r, this);
          }));
        },
        send: function send(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return T(o, void 0, void 0, s().mark(function r() {
            var n, i, o, a, c, u, l, d, h;
            return s().wrap(function (r) {
              for (;;) switch (r.prev = r.next) {
                case 0:
                  return r.next = 2, this._config;
                case 2:
                  if (n = r.sent, i = n.pkceRequiredForEmailMagicLinks, o = void 0, !i) {
                    r.next = 9;
                    break;
                  }
                  return r.next = 8, this.getCodeChallenge();
                case 8:
                  o = r.sent;
                case 9:
                  return r.next = 11, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
                case 11:
                  return a = r.sent, c = a.dfp_telemetry_id, u = a.captcha_token, l = Object.assign(Object.assign({}, t), {
                    email: e,
                    code_challenge: o,
                    captcha_token: u,
                    dfp_telemetry_id: c
                  }), d = !!this._subscriptionService.getSession(), h = d ? "/magic_links/email/send/secondary" : "/magic_links/email/send/primary", r.abrupt("return", this._networkClient.retriableFetchSDK({
                    url: h,
                    body: l,
                    errorMessage: "Failed to send magic link",
                    method: "POST",
                    retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                  }));
                case 18:
                case "end":
                  return r.stop();
              }
            }, r, this);
          }));
        }
      }, this.authenticate = function (e, t) {
        return T(o, void 0, void 0, s().mark(function r() {
          var n, i;
          return s().wrap(function (r) {
            for (;;) switch (r.prev = r.next) {
              case 0:
                return re("stytch.magicLinks.authenticate").isString("Token", e).isNumber("session_duration_minutes", t.session_duration_minutes), r.next = 3, this._passwordResetPKCEManager.getPKPair();
              case 3:
                if (n = r.sent, i = null, !(null == n ? void 0 : n.code_verifier)) {
                  r.next = 19;
                  break;
                }
                return r.prev = 6, r.next = 9, this.handlePKCEForAuthenticate(this._passwordResetPKCEManager, Object.assign(Object.assign({}, t), {
                  token: e
                }));
              case 9:
                i = r.sent, r.next = 19;
                break;
              case 12:
                if (r.prev = 12, r.t0 = r["catch"](6), !r.t0.message.includes("pkce")) {
                  r.next = 18;
                  break;
                }
                console.log("Authenticate with passwords pkce namespace failed. Falling back to authenticate with magic_links namespace."), r.next = 19;
                break;
              case 18:
                throw r.t0;
              case 19:
                if (i) {
                  r.next = 23;
                  break;
                }
                return r.next = 22, this.handlePKCEForAuthenticate(this._pkceManager, Object.assign(Object.assign({}, t), {
                  token: e
                }));
              case 22:
                i = r.sent;
              case 23:
                return this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: i.session,
                    user: i.user
                  },
                  session_token: i.session_token,
                  session_jwt: i.session_jwt,
                  intermediate_session_token: null
                }), r.abrupt("return", ie(i));
              case 25:
              case "end":
                return r.stop();
            }
          }, r, this, [[6, 12]]);
        }));
      };
    }
    return a(e, [{
      key: "getCodeChallenge",
      value: function value() {
        return T(this, void 0, void 0, s().mark(function e() {
          var t;
          return s().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this._pkceManager.getPKPair();
              case 2:
                if (!(t = e.sent)) {
                  e.next = 5;
                  break;
                }
                return e.abrupt("return", t.code_challenge);
              case 5:
                return e.next = 7, this._pkceManager.startPKCETransaction();
              case 7:
                return t = e.sent, e.abrupt("return", t.code_challenge);
              case 9:
              case "end":
                return e.stop();
            }
          }, e, this);
        }));
      }
    }, {
      key: "handlePKCEForAuthenticate",
      value: function value(e, t) {
        return T(this, void 0, void 0, s().mark(function r() {
          var n, i, o;
          return s().wrap(function (r) {
            for (;;) switch (r.prev = r.next) {
              case 0:
                return r.next = 2, e.getPKPair();
              case 2:
                return n = r.sent, i = Object.assign({
                  code_verifier: null == n ? void 0 : n.code_verifier
                }, t), r.next = 6, this._networkClient.fetchSDK({
                  url: "/magic_links/authenticate",
                  body: i,
                  errorMessage: "Failed to authenticate token.",
                  method: "POST"
                });
              case 6:
                return o = r.sent, e.clearPKPair(), r.abrupt("return", o);
              case 9:
              case "end":
                return r.stop();
            }
          }, r, this);
        }));
      }
    }]), e;
  }(),
  pe = a(function e(t, r) {
    var n = this,
      i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : function () {
        return Promise.resolve(void 0);
      },
      o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : oe();
    c(this, e), this._networkClient = t, this._subscriptionService = r, this.executeRecaptcha = i, this.dfpProtectedAuth = o, this.sms = {
      loginOrCreate: function loginOrCreate(e, t) {
        return T(n, void 0, void 0, s().mark(function r() {
          var n, i, o, a;
          return s().wrap(function (r) {
            for (;;) switch (r.prev = r.next) {
              case 0:
                return r.next = 2, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 2:
                return n = r.sent, i = n.dfp_telemetry_id, o = n.captcha_token, a = Object.assign(Object.assign({}, t), {
                  phone_number: e,
                  captcha_token: o,
                  dfp_telemetry_id: i
                }), r.abrupt("return", this._networkClient.retriableFetchSDK({
                  url: "/otps/sms/login_or_create",
                  body: a,
                  errorMessage: "Failed to send one time passcode",
                  method: "POST",
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                }));
              case 7:
              case "end":
                return r.stop();
            }
          }, r, this);
        }));
      },
      send: function send(e, t) {
        return T(n, void 0, void 0, s().mark(function r() {
          var n, i, o, a, c, u;
          return s().wrap(function (r) {
            for (;;) switch (r.prev = r.next) {
              case 0:
                return r.next = 2, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 2:
                return n = r.sent, i = n.dfp_telemetry_id, o = n.captcha_token, a = Object.assign(Object.assign({}, t), {
                  phone_number: e,
                  captcha_token: o,
                  dfp_telemetry_id: i
                }), c = !!this._subscriptionService.getSession(), u = c ? "/otps/sms/send/secondary" : "/otps/sms/send/primary", r.abrupt("return", this._networkClient.retriableFetchSDK({
                  url: u,
                  body: a,
                  errorMessage: "Failed to send one time passcode",
                  method: "POST",
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                }));
              case 9:
              case "end":
                return r.stop();
            }
          }, r, this);
        }));
      }
    }, this.whatsapp = {
      loginOrCreate: function loginOrCreate(e, t) {
        return T(n, void 0, void 0, s().mark(function r() {
          var n, i, o, a;
          return s().wrap(function (r) {
            for (;;) switch (r.prev = r.next) {
              case 0:
                return r.next = 2, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 2:
                return n = r.sent, i = n.dfp_telemetry_id, o = n.captcha_token, a = Object.assign(Object.assign({}, t), {
                  phone_number: e,
                  dfp_telemetry_id: i,
                  captcha_token: o
                }), r.abrupt("return", this._networkClient.retriableFetchSDK({
                  url: "/otps/whatsapp/login_or_create",
                  body: a,
                  errorMessage: "Failed to send one time passcode",
                  method: "POST",
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                }));
              case 7:
              case "end":
                return r.stop();
            }
          }, r, this);
        }));
      },
      send: function send(e, t) {
        return T(n, void 0, void 0, s().mark(function r() {
          var n, i, o, a, c, u;
          return s().wrap(function (r) {
            for (;;) switch (r.prev = r.next) {
              case 0:
                return r.next = 2, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 2:
                return n = r.sent, i = n.dfp_telemetry_id, o = n.captcha_token, a = Object.assign(Object.assign({}, t), {
                  phone_number: e,
                  captcha_token: o,
                  dfp_telemetry_id: i
                }), c = !!this._subscriptionService.getSession(), u = c ? "/otps/whatsapp/send/secondary" : "/otps/whatsapp/send/primary", r.abrupt("return", this._networkClient.retriableFetchSDK({
                  url: u,
                  body: a,
                  errorMessage: "Failed to send one time passcode",
                  method: "POST",
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                }));
              case 9:
              case "end":
                return r.stop();
            }
          }, r, this);
        }));
      }
    }, this.email = {
      loginOrCreate: function loginOrCreate(e, t) {
        return T(n, void 0, void 0, s().mark(function r() {
          var n, i;
          return s().wrap(function (r) {
            for (;;) switch (r.prev = r.next) {
              case 0:
                return r.next = 2, this.executeRecaptcha();
              case 2:
                return n = r.sent, i = Object.assign(Object.assign({}, t), {
                  email: e,
                  captcha_token: n
                }), r.abrupt("return", this._networkClient.fetchSDK({
                  url: "/otps/email/login_or_create",
                  body: i,
                  errorMessage: "Failed to send one time passcode",
                  method: "POST"
                }));
              case 5:
              case "end":
                return r.stop();
            }
          }, r, this);
        }));
      },
      send: function send(e, t) {
        return T(n, void 0, void 0, s().mark(function r() {
          var n, i, o, a;
          return s().wrap(function (r) {
            for (;;) switch (r.prev = r.next) {
              case 0:
                return r.next = 2, this.executeRecaptcha();
              case 2:
                return n = r.sent, i = Object.assign(Object.assign({}, t), {
                  email: e,
                  captcha_token: n
                }), o = !!this._subscriptionService.getSession(), a = o ? "/otps/email/send/secondary" : "/otps/email/send/primary", r.abrupt("return", this._networkClient.fetchSDK({
                  url: a,
                  body: i,
                  errorMessage: "Failed to send one time passcode",
                  method: "POST"
                }));
              case 7:
              case "end":
                return r.stop();
            }
          }, r, this);
        }));
      }
    }, this.authenticate = function (e, t, r) {
      return T(n, void 0, void 0, s().mark(function n() {
        var i, o, a, c, u;
        return s().wrap(function (n) {
          for (;;) switch (n.prev = n.next) {
            case 0:
              return re("stytch.otps.authenticate").isString("Code", e).isNumber("session_duration_minutes", r.session_duration_minutes), n.next = 3, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
            case 3:
              return i = n.sent, o = i.dfp_telemetry_id, a = i.captcha_token, c = Object.assign({
                token: e,
                method_id: t,
                dfp_telemetry_id: o,
                captcha_token: a
              }, r), n.next = 9, this._networkClient.retriableFetchSDK({
                url: "/otps/authenticate",
                body: c,
                errorMessage: "Failed to authenticate token.",
                method: "POST",
                retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
              });
            case 9:
              return u = n.sent, this._subscriptionService.updateStateAndTokens({
                state: {
                  session: u.session,
                  user: u.user
                },
                session_token: u.session_token,
                session_jwt: u.session_jwt,
                intermediate_session_token: null
              }), n.abrupt("return", ie(u));
            case 12:
            case "end":
              return n.stop();
          }
        }, n, this);
      }));
    };
  }),
  fe = function () {
    function e(t, r, n, i, s) {
      c(this, e), this._networkClient = t, this._subscriptionService = r, this._pkceManager = n, this._dynamicConfig = i, this._config = s, this.google = {
        start: this.startOAuthFlow(y.Google)
      }, this.apple = {
        start: this.startOAuthFlow(y.Apple)
      }, this.microsoft = {
        start: this.startOAuthFlow(y.Microsoft)
      }, this.github = {
        start: this.startOAuthFlow(y.Github)
      }, this.gitlab = {
        start: this.startOAuthFlow(y.GitLab)
      }, this.facebook = {
        start: this.startOAuthFlow(y.Facebook)
      }, this.discord = {
        start: this.startOAuthFlow(y.Discord)
      }, this.salesforce = {
        start: this.startOAuthFlow(y.Salesforce)
      }, this.slack = {
        start: this.startOAuthFlow(y.Slack)
      }, this.amazon = {
        start: this.startOAuthFlow(y.Amazon)
      }, this.bitbucket = {
        start: this.startOAuthFlow(y.Bitbucket)
      }, this.linkedin = {
        start: this.startOAuthFlow(y.LinkedIn)
      }, this.coinbase = {
        start: this.startOAuthFlow(y.Coinbase)
      }, this.twitch = {
        start: this.startOAuthFlow(y.Twitch)
      }, this.twitter = {
        start: this.startOAuthFlow(y.Twitter)
      }, this.tiktok = {
        start: this.startOAuthFlow(y.TikTok)
      }, this.snapchat = {
        start: this.startOAuthFlow(y.Snapchat)
      }, this.figma = {
        start: this.startOAuthFlow(y.Figma)
      }, this.yahoo = {
        start: this.startOAuthFlow(y.Yahoo)
      };
    }
    return a(e, [{
      key: "authenticate",
      value: function value(e, t) {
        return T(this, void 0, void 0, s().mark(function r() {
          var n, i;
          return s().wrap(function (r) {
            for (;;) switch (r.prev = r.next) {
              case 0:
                return re("stytch.oauth.authenticate").isString("Token", e).isNumber("session_duration_minutes", t.session_duration_minutes), r.next = 3, this._pkceManager.getPKPair();
              case 3:
                return (n = r.sent) || Q("No code verifier found in local storage for OAuth flow.\nConsider using stytch.oauth.$provider.start() to add PKCE to your OAuth flows for added security.\nSee https://stytch.com/docs/oauth#guides_pkce for more information."), r.next = 7, this._networkClient.fetchSDK({
                  url: "/oauth/authenticate",
                  method: "POST",
                  body: Object.assign({
                    token: e,
                    code_verifier: null == n ? void 0 : n.code_verifier
                  }, t),
                  errorMessage: "Failed to authenticate token"
                });
              case 7:
                return i = r.sent, this._pkceManager.clearPKPair(), this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: i.session,
                    user: ne(i.__user)
                  },
                  session_token: i.session_token,
                  session_jwt: i.session_jwt,
                  intermediate_session_token: null
                }), r.abrupt("return", ie(i));
              case 11:
              case "end":
                return r.stop();
            }
          }, r, this);
        }));
      }
    }, {
      key: "getBaseApiUrl",
      value: function value() {
        return T(this, void 0, void 0, s().mark(function e() {
          var t, r;
          return s().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this._dynamicConfig;
              case 2:
                if (t = e.sent, !(r = t.cnameDomain)) {
                  e.next = 6;
                  break;
                }
                return e.abrupt("return", "https://".concat(r));
              case 6:
                if (!this._config.publicToken.includes("public-token-test")) {
                  e.next = 8;
                  break;
                }
                return e.abrupt("return", this._config.testAPIURL);
              case 8:
                return e.abrupt("return", this._config.liveAPIURL);
              case 9:
              case "end":
                return e.stop();
            }
          }, e, this);
        }));
      }
    }, {
      key: "startOAuthFlow",
      value: function value(e) {
        var t = this;
        return function () {
          var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            n = r.login_redirect_url,
            i = r.signup_redirect_url,
            o = r.custom_scopes,
            a = r.provider_params;
          return T(t, void 0, void 0, s().mark(function t() {
            var r, c, u, l, d, h, p;
            return s().wrap(function (t) {
              for (;;) switch (t.prev = t.next) {
                case 0:
                  return t.next = 2, this._dynamicConfig;
                case 2:
                  return r = t.sent, c = r.cnameDomain, u = r.pkceRequiredForOAuth, t.next = 7, this.getBaseApiUrl();
                case 7:
                  if (l = t.sent, this._networkClient.logEvent({
                    name: "start_oauth_flow",
                    details: {
                      provider_type: e,
                      custom_scopes: o,
                      cname_domain: c,
                      pkce: u,
                      provider_params: a
                    }
                  }), (d = new URL("".concat(l, "/v1/public/oauth/").concat(e, "/start"))).searchParams.set("public_token", this._config.publicToken), !u) {
                    t.next = 18;
                    break;
                  }
                  return t.next = 14, this._pkceManager.startPKCETransaction();
                case 14:
                  h = t.sent, d.searchParams.set("code_challenge", h.code_challenge), t.next = 19;
                  break;
                case 18:
                  this._pkceManager.clearPKPair();
                case 19:
                  if (o && (re("startOAuthFlow").isStringArray("custom_scopes", o), d.searchParams.set("custom_scopes", o.join(" "))), a) for (p in re("startOAuthFlow").isOptionalObject("provider_params", a), a) d.searchParams.set("provider_" + p, a[p]);
                  n && d.searchParams.set("login_redirect_url", n), i && d.searchParams.set("signup_redirect_url", i), window.location.href = d.toString();
                case 24:
                case "end":
                  return t.stop();
              }
            }, t, this);
          }));
        };
      }
    }]), e;
  }(),
  _e = function () {
    function e(t, r) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : function () {
          return Promise.resolve(void 0);
        },
        i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : oe();
      c(this, e), this._networkClient = t, this._subscriptionService = r, this.executeRecaptcha = n, this.dfpProtectedAuth = i;
    }
    return a(e, [{
      key: "authenticateStart",
      value: function value(e) {
        return T(this, void 0, void 0, s().mark(function t() {
          var r, n, i;
          return s().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return re("stytch.cryptoWallets.authenticateStart").isString("crypto_wallet_address", e.crypto_wallet_address).isString("crypto_wallet_type", e.crypto_wallet_type), r = !!this._subscriptionService.getSession(), t.next = 4, this.executeRecaptcha();
              case 4:
                return n = t.sent, i = r ? "/crypto_wallets/authenticate/start/secondary" : "/crypto_wallets/authenticate/start/primary", t.abrupt("return", this._networkClient.fetchSDK({
                  url: i,
                  method: "POST",
                  errorMessage: "Failed to start wallet authentication.",
                  body: {
                    crypto_wallet_address: e.crypto_wallet_address,
                    crypto_wallet_type: e.crypto_wallet_type,
                    captcha_token: n
                  }
                }));
              case 7:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }, {
      key: "authenticate",
      value: function value(e) {
        return T(this, void 0, void 0, s().mark(function t() {
          var r, n, i, o;
          return s().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return re("stytch.cryptoWallets.authenticate").isString("signature", e.signature).isString("crypto_wallet_address", e.crypto_wallet_address).isString("crypto_wallet_type", e.crypto_wallet_type).isNumber("session_duration_minutes", e.session_duration_minutes), t.next = 3, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 3:
                return r = t.sent, n = r.dfp_telemetry_id, i = r.captcha_token, t.next = 8, this._networkClient.retriableFetchSDK({
                  url: "/crypto_wallets/authenticate",
                  method: "POST",
                  errorMessage: "Failed to authenticate.",
                  body: {
                    session_duration_minutes: e.session_duration_minutes,
                    crypto_wallet_address: e.crypto_wallet_address,
                    crypto_wallet_type: e.crypto_wallet_type,
                    signature: e.signature,
                    captcha_token: i,
                    dfp_telemetry_id: n
                  },
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                });
              case 8:
                return o = t.sent, this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: o.session,
                    user: ne(o.__user)
                  },
                  session_token: o.session_token,
                  session_jwt: o.session_jwt,
                  intermediate_session_token: null
                }), t.abrupt("return", ie(o));
              case 11:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }]), e;
  }(),
  me = function () {
    function e(t, r, n) {
      c(this, e), this._networkClient = t, this._subscriptionService = r, this.dfpProtectedAuth = n;
    }
    return a(e, [{
      key: "create",
      value: function value(e) {
        return T(this, void 0, void 0, s().mark(function t() {
          var r;
          return s().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return re("stytch.totps.create").isNumber("expiration_minutes", e.expiration_minutes), t.next = 3, this._networkClient.fetchSDK({
                  url: "/totps",
                  method: "POST",
                  errorMessage: "Failed to create TOTP",
                  body: {
                    expiration_minutes: e.expiration_minutes
                  }
                });
              case 3:
                return r = t.sent, this._subscriptionService.updateUser(r.__user), t.abrupt("return", ie(r));
              case 6:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }, {
      key: "authenticate",
      value: function value(e) {
        return T(this, void 0, void 0, s().mark(function t() {
          var r, n, i, o;
          return s().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return re("stytch.totps.authenticate").isNumber("session_duration_minutes", e.session_duration_minutes).isString("totp_code", e.totp_code), t.next = 3, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 3:
                return r = t.sent, n = r.dfp_telemetry_id, i = r.captcha_token, t.next = 8, this._networkClient.retriableFetchSDK({
                  url: "/totps/authenticate",
                  method: "POST",
                  errorMessage: "Failed to authenticate TOTP",
                  body: {
                    session_duration_minutes: e.session_duration_minutes,
                    totp_code: e.totp_code,
                    captcha_token: i,
                    dfp_telemetry_id: n
                  },
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                });
              case 8:
                return o = t.sent, this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: o.session,
                    user: o.__user
                  },
                  session_token: o.session_token,
                  session_jwt: o.session_jwt,
                  intermediate_session_token: null
                }), t.abrupt("return", ie(o));
              case 11:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }, {
      key: "recoveryCodes",
      value: function value() {
        return T(this, void 0, void 0, s().mark(function e() {
          return s().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", this._networkClient.fetchSDK({
                  url: "/totps/recovery_codes",
                  method: "POST",
                  errorMessage: "Failed to retrieve recovery codes"
                }));
              case 1:
              case "end":
                return e.stop();
            }
          }, e, this);
        }));
      }
    }, {
      key: "recover",
      value: function value(e) {
        return T(this, void 0, void 0, s().mark(function t() {
          var r, n, i, o;
          return s().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return re("stytch.totps.recover").isNumber("session_duration_minutes", e.session_duration_minutes).isString("recovery_code", e.recovery_code), t.next = 3, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 3:
                return r = t.sent, n = r.dfp_telemetry_id, i = r.captcha_token, t.next = 8, this._networkClient.retriableFetchSDK({
                  url: "/totps/recover",
                  method: "POST",
                  errorMessage: "Failed to recover TOTP",
                  body: {
                    session_duration_minutes: e.session_duration_minutes,
                    recovery_code: e.recovery_code,
                    captcha_token: i,
                    dfp_telemetry_id: n
                  },
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                });
              case 8:
                return o = t.sent, this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: o.session,
                    user: o.__user
                  },
                  session_token: o.session_token,
                  session_jwt: o.session_jwt,
                  intermediate_session_token: null
                }), t.abrupt("return", ie(o));
              case 11:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }]), e;
  }();
function ve(e) {
  for (var t = "==".slice(0, (4 - e.length % 4) % 4), r = e.replace(/-/g, "+").replace(/_/g, "/") + t, n = atob(r), i = new ArrayBuffer(n.length), s = new Uint8Array(i), o = 0; o < n.length; o++) s[o] = n.charCodeAt(o);
  return i;
}
function ye(t) {
  var r,
    n = "",
    i = e(new Uint8Array(t));
  try {
    for (i.s(); !(r = i.n()).done;) {
      var s = r.value;
      n += String.fromCharCode(s);
    }
  } catch (e) {
    i.e(e);
  } finally {
    i.f();
  }
  return btoa(n).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
var ge = "copy",
  be = "convert";
function ke(e, r, n) {
  if (r === ge) return n;
  if (r === be) return e(n);
  if (r instanceof Array) return n.map(function (t) {
    return ke(e, r[0], t);
  });
  if (r instanceof Object) {
    for (var i = {}, s = 0, o = Object.entries(r); s < o.length; s++) {
      var a = t(o[s], 2),
        c = a[0],
        u = a[1];
      if (u.derive) {
        var l = u.derive(n);
        void 0 !== l && (n[c] = l);
      }
      if (c in n) null != n[c] ? i[c] = ke(e, u.schema, n[c]) : i[c] = null;else if (u.required) throw new Error("Missing key: ".concat(c));
    }
    return i;
  }
}
function we(e, t) {
  return {
    required: !0,
    schema: e,
    derive: t
  };
}
function Se(e) {
  return {
    required: !0,
    schema: e
  };
}
function Ce(e) {
  return {
    required: !1,
    schema: e
  };
}
var Ae = {
    type: Se(ge),
    id: Se(be),
    transports: Ce(ge)
  },
  Te = {
    appid: Ce(ge),
    appidExclude: Ce(ge),
    credProps: Ce(ge)
  },
  Oe = {
    appid: Ce(ge),
    appidExclude: Ce(ge),
    credProps: Ce(ge)
  },
  Ee = {
    publicKey: Se({
      rp: Se(ge),
      user: Se({
        id: Se(be),
        name: Se(ge),
        displayName: Se(ge)
      }),
      challenge: Se(be),
      pubKeyCredParams: Se(ge),
      timeout: Ce(ge),
      excludeCredentials: Ce([Ae]),
      authenticatorSelection: Ce(ge),
      attestation: Ce(ge),
      extensions: Ce(Te)
    }),
    signal: Ce(ge)
  },
  Pe = {
    type: Se(ge),
    id: Se(ge),
    rawId: Se(be),
    authenticatorAttachment: Ce(ge),
    response: Se({
      clientDataJSON: Se(be),
      attestationObject: Se(be),
      transports: we(ge, function (e) {
        var t;
        return (null == (t = e.getTransports) ? void 0 : t.call(e)) || [];
      })
    }),
    clientExtensionResults: we(Oe, function (e) {
      return e.getClientExtensionResults();
    })
  },
  xe = {
    mediation: Ce(ge),
    publicKey: Se({
      challenge: Se(be),
      timeout: Ce(ge),
      rpId: Ce(ge),
      allowCredentials: Ce([Ae]),
      userVerification: Ce(ge),
      extensions: Ce(Te)
    }),
    signal: Ce(ge)
  },
  Re = {
    type: Se(ge),
    id: Se(ge),
    rawId: Se(be),
    authenticatorAttachment: Ce(ge),
    response: Se({
      clientDataJSON: Se(be),
      authenticatorData: Se(be),
      signature: Se(be),
      userHandle: Se(be)
    }),
    clientExtensionResults: we(Oe, function (e) {
      return e.getClientExtensionResults();
    })
  };
function De(e) {
  return ke(ve, Ee, e);
}
function Ie(e) {
  return ke(ye, Pe, e);
}
function Be(e) {
  return T(this, void 0, void 0, s().mark(function t() {
    var r;
    return s().wrap(function (t) {
      for (;;) switch (t.prev = t.next) {
        case 0:
          return t.next = 2, navigator.credentials.create(De(e));
        case 2:
          return r = t.sent, t.abrupt("return", Ie(r));
        case 4:
        case "end":
          return t.stop();
      }
    }, t);
  }));
}
function Le(e) {
  return ke(ve, xe, e);
}
function Fe(e) {
  return ke(ye, Re, e);
}
function je(e) {
  return T(this, void 0, void 0, s().mark(function t() {
    var r;
    return s().wrap(function (t) {
      for (;;) switch (t.prev = t.next) {
        case 0:
          return t.next = 2, navigator.credentials.get(Le(e));
        case 2:
          return r = t.sent, t.abrupt("return", Fe(r));
        case 4:
        case "end":
          return t.stop();
      }
    }, t);
  }));
}
var Me = function () {
    function e(t, r, n) {
      c(this, e), this._networkClient = t, this._subscriptionService = r, this.dfpProtectedAuth = n, this.checkEligibleInputs = function () {
        return !(document.querySelectorAll("input[autocomplete*='webauthn']").length < 1) || (console.error('No <input> with `"webauthn"` in its `autocomplete` attribute was detected'), !1);
      };
    }
    return a(e, [{
      key: "register",
      value: function value(e) {
        var t, r;
        return T(this, void 0, void 0, s().mark(function n() {
          var i, o, a, c, u;
          return s().wrap(function (n) {
            for (;;) switch (n.prev = n.next) {
              case 0:
                return re("stytch.webauthn.register").isOptionalString("domain", null == e ? void 0 : e.domain).isOptionalString("authenticator_type", null == e ? void 0 : e.authenticator_type).isOptionalBoolean("is_passkey", null == e ? void 0 : e.is_passkey).isOptionalNumber("session_duration_minutes", null == e ? void 0 : e.session_duration_minutes), n.next = 3, this._networkClient.fetchSDK({
                  url: "/webauthn/register/start",
                  method: "POST",
                  errorMessage: "Failed to start WebAuthn registration",
                  body: {
                    domain: null !== (t = null == e ? void 0 : e.domain) && void 0 !== t ? t : window.location.hostname,
                    authenticator_type: null !== (r = null == e ? void 0 : e.authenticator_type) && void 0 !== r ? r : void 0,
                    return_passkey_credential_options: null == e ? void 0 : e.is_passkey,
                    user_agent: navigator.userAgent
                  }
                });
              case 3:
                return i = n.sent, o = i.public_key_credential_creation_options, a = JSON.parse(o), n.next = 8, Be({
                  publicKey: a
                });
              case 8:
                return c = n.sent, n.next = 11, this._networkClient.fetchSDK({
                  url: "/webauthn/register",
                  method: "POST",
                  errorMessage: "Failed to register WebAuthn device",
                  body: {
                    public_key_credential: JSON.stringify(c),
                    session_duration_minutes: null == e ? void 0 : e.session_duration_minutes
                  }
                });
              case 11:
                return u = n.sent, this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: u.session,
                    user: u.__user
                  },
                  session_token: u.session_token,
                  session_jwt: u.session_jwt,
                  intermediate_session_token: null
                }), n.abrupt("return", ie(u));
              case 14:
              case "end":
                return n.stop();
            }
          }, n, this);
        }));
      }
    }, {
      key: "authenticate",
      value: function value(e) {
        var t, r;
        return T(this, void 0, void 0, s().mark(function n() {
          var i, o, a, c, u, l, d, h, p, f, _, m;
          return s().wrap(function (n) {
            for (;;) switch (n.prev = n.next) {
              case 0:
                return re("stytch.webauthn.authenticate").isOptionalString("domain", e.domain).isNumber("session_duration_minutes", e.session_duration_minutes).isOptionalBoolean("is_passkey", e.is_passkey).isOptionalObject("signal", e.signal), n.next = 3, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 3:
                if (i = n.sent, o = i.dfp_telemetry_id, a = i.captcha_token, !e.conditional_mediation) {
                  n.next = 14;
                  break;
                }
                return n.next = 9, this.browserSupportsAutofill();
              case 9:
                if (n.sent) {
                  n.next = 12;
                  break;
                }
                return console.error("Browser does not support WebAuthn autofill"), n.abrupt("return", null);
              case 12:
                if (this.checkEligibleInputs()) {
                  n.next = 14;
                  break;
                }
                return n.abrupt("return", null);
              case 14:
                return c = !!this._subscriptionService.getSession(), u = c ? "/webauthn/authenticate/start/secondary" : "/webauthn/authenticate/start/primary", n.next = 18, this._networkClient.fetchSDK({
                  url: u,
                  method: "POST",
                  errorMessage: "Failed to start WebAuthn authentication",
                  body: {
                    domain: null !== (t = e.domain) && void 0 !== t ? t : window.location.hostname,
                    return_passkey_credential_options: null == e ? void 0 : e.is_passkey
                  }
                });
              case 18:
                return l = n.sent, d = l.public_key_credential_request_options, h = new AbortController(), p = {
                  publicKey: JSON.parse(d),
                  signal: null !== (r = e.signal) && void 0 !== r ? r : h.signal
                }, f = Object.assign(Object.assign({}, p), {
                  mediation: "conditional"
                }), n.next = 25, je(e.conditional_mediation ? f : p);
              case 25:
                return _ = n.sent, n.next = 28, this._networkClient.retriableFetchSDK({
                  url: "/webauthn/authenticate",
                  method: "POST",
                  errorMessage: "Failed to authenticate WebAuthn device",
                  body: {
                    public_key_credential: JSON.stringify(_),
                    session_duration_minutes: e.session_duration_minutes,
                    dfp_telemetry_id: o,
                    captcha_token: a
                  },
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                });
              case 28:
                return m = n.sent, this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: m.session,
                    user: m.__user
                  },
                  session_token: m.session_token,
                  session_jwt: m.session_jwt,
                  intermediate_session_token: null
                }), n.abrupt("return", ie(m));
              case 31:
              case "end":
                return n.stop();
            }
          }, n, this);
        }));
      }
    }, {
      key: "update",
      value: function value(e) {
        return T(this, void 0, void 0, s().mark(function t() {
          var r;
          return s().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return r = "/webauthn/update/" + e.webauthn_registration_id, t.next = 3, this._networkClient.fetchSDK({
                  url: r,
                  method: "PUT",
                  errorMessage: "Failed to update WebAuthn Registration",
                  body: {
                    name: e.name
                  }
                });
              case 3:
                return t.abrupt("return", t.sent);
              case 4:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }, {
      key: "browserSupportsAutofill",
      value: function value() {
        return T(this, void 0, void 0, s().mark(function e() {
          var t;
          return s().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (void 0 !== (t = window.PublicKeyCredential) && void 0 !== t.isConditionalMediationAvailable) {
                  e.next = 3;
                  break;
                }
                return e.abrupt("return", new Promise(function (e) {
                  return e(!1);
                }));
              case 3:
                return e.abrupt("return", t.isConditionalMediationAvailable());
              case 4:
              case "end":
                return e.stop();
            }
          }, e);
        }));
      }
    }]), e;
  }(),
  Ne = Promise.resolve({
    pkceRequiredForPasswordResets: !1
  }),
  Ue = function () {
    function e(t, r, n) {
      var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : Ne,
        s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : oe();
      c(this, e), this._networkClient = t, this._subscriptionService = r, this._pkceManager = n, this._config = i, this.dfpProtectedAuth = s;
    }
    return a(e, [{
      key: "getCodeChallenge",
      value: function value() {
        return T(this, void 0, void 0, s().mark(function e() {
          var t, r;
          return s().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this._config;
              case 2:
                if (t = e.sent, t.pkceRequiredForPasswordResets) {
                  e.next = 6;
                  break;
                }
                return e.abrupt("return", void 0);
              case 6:
                return e.next = 8, this._pkceManager.getPKPair();
              case 8:
                if (!(r = e.sent)) {
                  e.next = 11;
                  break;
                }
                return e.abrupt("return", r.code_challenge);
              case 11:
                return e.next = 13, this._pkceManager.startPKCETransaction();
              case 13:
                return r = e.sent, e.abrupt("return", r.code_challenge);
              case 15:
              case "end":
                return e.stop();
            }
          }, e, this);
        }));
      }
    }, {
      key: "create",
      value: function value(e) {
        return T(this, void 0, void 0, s().mark(function t() {
          var r, n, i, o;
          return s().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return re("stytch.passwords.create").isString("password", e.password).isString("email", e.email).isNumber("session_duration_minutes", e.session_duration_minutes), t.next = 3, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 3:
                return r = t.sent, n = r.dfp_telemetry_id, i = r.captcha_token, t.next = 8, this._networkClient.retriableFetchSDK({
                  url: "/passwords",
                  method: "POST",
                  errorMessage: "Failed to create password.",
                  body: {
                    email: e.email,
                    password: e.password,
                    session_duration_minutes: e.session_duration_minutes,
                    captcha_token: i,
                    dfp_telemetry_id: n
                  },
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                });
              case 8:
                return o = t.sent, this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: o.session,
                    user: o.user
                  },
                  session_token: o.session_token,
                  session_jwt: o.session_jwt,
                  intermediate_session_token: null
                }), t.abrupt("return", ie(o));
              case 11:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }, {
      key: "authenticate",
      value: function value(e) {
        return T(this, void 0, void 0, s().mark(function t() {
          var r, n, i, o;
          return s().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return re("stytch.passwords.authenticate").isString("password", e.password).isString("email", e.email).isNumber("session_duration_minutes", e.session_duration_minutes), t.next = 3, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 3:
                return r = t.sent, n = r.dfp_telemetry_id, i = r.captcha_token, t.next = 8, this._networkClient.retriableFetchSDK({
                  url: "/passwords/authenticate",
                  method: "POST",
                  errorMessage: "Failed to authenticate password.",
                  body: {
                    email: e.email,
                    password: e.password,
                    session_duration_minutes: e.session_duration_minutes,
                    captcha_token: i,
                    dfp_telemetry_id: n
                  },
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                });
              case 8:
                return o = t.sent, this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: o.session,
                    user: o.user
                  },
                  session_token: o.session_token,
                  session_jwt: o.session_jwt,
                  intermediate_session_token: null
                }), t.abrupt("return", ie(o));
              case 11:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }, {
      key: "resetByEmailStart",
      value: function value(e) {
        return T(this, void 0, void 0, s().mark(function t() {
          var r, n, i, o;
          return s().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return re("stytch.passwords.resetByEmailStart").isString("email", e.email).isOptionalString("login_redirect_url", e.login_redirect_url).isOptionalString("reset_password_redirect_url", e.reset_password_redirect_url).isOptionalString("reset_password_template_id", e.reset_password_template_id).isOptionalNumber("reset_password_expiration_minutes", e.reset_password_expiration_minutes), t.next = 3, this.getCodeChallenge();
              case 3:
                return r = t.sent, t.next = 6, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 6:
                return n = t.sent, i = n.dfp_telemetry_id, o = n.captcha_token, t.abrupt("return", this._networkClient.retriableFetchSDK({
                  url: "/passwords/email/reset/start",
                  method: "POST",
                  errorMessage: "Failed to start password reset flow.",
                  body: {
                    email: e.email,
                    login_redirect_url: e.login_redirect_url,
                    reset_password_redirect_url: e.reset_password_redirect_url,
                    reset_password_expiration_minutes: e.reset_password_expiration_minutes,
                    reset_password_template_id: e.reset_password_template_id,
                    code_challenge: r,
                    captcha_token: o,
                    dfp_telemetry_id: i
                  },
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                }));
              case 10:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }, {
      key: "resetByEmail",
      value: function value(e) {
        return T(this, void 0, void 0, s().mark(function t() {
          var r, n, i, o, a, c;
          return s().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return re("stytch.passwords.resetByEmail").isString("token", e.token).isString("password", e.password).isNumber("session_duration_minutes", e.session_duration_minutes), t.next = 3, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 3:
                return r = t.sent, n = r.dfp_telemetry_id, i = r.captcha_token, t.next = 8, this._pkceManager.getPKPair();
              case 8:
                return o = t.sent, a = null == o ? void 0 : o.code_verifier, t.next = 12, this._networkClient.retriableFetchSDK({
                  url: "/passwords/email/reset",
                  method: "POST",
                  errorMessage: "Failed to reset password.",
                  body: {
                    token: e.token,
                    password: e.password,
                    session_duration_minutes: e.session_duration_minutes,
                    captcha_token: i,
                    code_verifier: a,
                    dfp_telemetry_id: n
                  },
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                });
              case 12:
                return c = t.sent, this._pkceManager.clearPKPair(), this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: c.session,
                    user: c.user
                  },
                  session_token: c.session_token,
                  session_jwt: c.session_jwt,
                  intermediate_session_token: null
                }), t.abrupt("return", ie(c));
              case 16:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }, {
      key: "resetByExistingPassword",
      value: function value(e) {
        return T(this, void 0, void 0, s().mark(function t() {
          var r, n, i, o;
          return s().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return re("stytch.passwords.resetByExistingPassword").isString("email", e.email).isString("existing_password", e.existing_password).isString("new_password", e.new_password).isNumber("session_duration_minutes", e.session_duration_minutes), t.next = 3, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 3:
                return r = t.sent, n = r.dfp_telemetry_id, i = r.captcha_token, t.next = 8, this._networkClient.retriableFetchSDK({
                  url: "/passwords/existing_password/reset",
                  method: "POST",
                  errorMessage: "Failed to reset password.",
                  body: {
                    email: e.email,
                    existing_password: e.existing_password,
                    new_password: e.new_password,
                    session_duration_minutes: e.session_duration_minutes,
                    dfp_telemetry_id: n,
                    captcha_token: i
                  },
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                });
              case 8:
                return o = t.sent, this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: o.session,
                    user: o.user
                  },
                  session_token: o.session_token,
                  session_jwt: o.session_jwt,
                  intermediate_session_token: null
                }), t.abrupt("return", ie(o));
              case 11:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }, {
      key: "resetBySession",
      value: function value(e) {
        return T(this, void 0, void 0, s().mark(function t() {
          var r, n, i, o;
          return s().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return re("stytch.passwords.resetBySession").isString("password", e.password), t.next = 3, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 3:
                return r = t.sent, n = r.dfp_telemetry_id, i = r.captcha_token, t.next = 8, this._networkClient.retriableFetchSDK({
                  url: "/passwords/session/reset",
                  method: "POST",
                  errorMessage: "Failed to reset by session.",
                  body: {
                    password: e.password,
                    session_duration_minutes: e.session_duration_minutes,
                    dfp_telemetry_id: n,
                    captcha_token: i
                  },
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                });
              case 8:
                return o = t.sent, this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: o.session,
                    user: o.user
                  },
                  session_token: o.session_token,
                  session_jwt: o.session_jwt,
                  intermediate_session_token: null
                }), t.abrupt("return", o);
              case 11:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }, {
      key: "strengthCheck",
      value: function value(e) {
        return T(this, void 0, void 0, s().mark(function t() {
          return s().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return re("stytch.passwords.strengthCheck").isOptionalString("email", e.email).isString("password", e.password), t.abrupt("return", this._networkClient.fetchSDK({
                  url: "/passwords/strength_check",
                  method: "POST",
                  errorMessage: "Failed to check password strength.",
                  body: {
                    email: e.email,
                    password: e.password
                  }
                }));
              case 2:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }]), e;
  }();
Promise.resolve({
  pkceRequiredForEmailMagicLinks: !1
}), Promise.resolve({
  pkceRequiredForPasswordResets: !1
});
var Ke = function () {
    function e(t) {
      c(this, e), this.iframeURL = t, this.createIframe();
    }
    return a(e, [{
      key: "createIframe",
      value: function value() {
        var e = document.querySelector('[src~="'.concat(this.iframeURL, '"]'));
        e ? Q("It looks like you're creating multiple copies of the Stytch client. This behavior is unsupported, and unintended side effects may occur. Make sure you are creating the Stytch client at the global level, and not inside a component's render function.") : ((e = document.createElement("iframe")).src = this.iframeURL, e.style.position = "absolute", e.style.width = "0", e.style.height = "0", e.style.border = "0", document.body.appendChild(e)), "true" !== e.dataset.loaded ? this.frame = new Promise(function (t) {
          e.addEventListener("load", function () {
            e.dataset.loaded = "true", t(e);
          }, {
            once: !0
          });
        }) : this.frame = Promise.resolve(e);
      }
    }, {
      key: "call",
      value: function value(e, t) {
        return T(this, void 0, void 0, s().mark(function r() {
          var n,
            i,
            o = this;
          return s().wrap(function (r) {
            for (;;) switch (r.prev = r.next) {
              case 0:
                return r.next = 2, this.frame;
              case 2:
                return n = r.sent, i = new MessageChannel(), r.abrupt("return", new Promise(function (r, s) {
                  var a;
                  i.port1.onmessage = function (e) {
                    var t = e.data;
                    i.port1.close(), t.success ? r(t.payload) : s(ae.unmarshall(t.error));
                  };
                  var c = {
                    method: e,
                    args: t
                  };
                  null === (a = n.contentWindow) || void 0 === a || a.postMessage(c, o.iframeURL, [i.port2]);
                }));
              case 5:
              case "end":
                return r.stop();
            }
          }, r, this);
        }));
      }
    }]), e;
  }(),
  We = function () {
    function e(t, r) {
      var n = this;
      c(this, e), this._subscriptionService = t, this._headlessSessionClient = r, this._onDataChange = function (e) {
        (null == e ? void 0 : e.session) ? n.scheduleBackgroundRefresh() : n.cancelBackgroundRefresh();
      }, this._reauthenticateWithBackoff = function () {
        return T(n, void 0, void 0, s().mark(function t() {
          var r;
          return s().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                r = 0;
              case 1:
                return t.prev = 2, t.next = 5, this._headlessSessionClient.authenticate();
              case 5:
                return t.abrupt("return", t.sent);
              case 8:
                if (t.prev = 8, t.t0 = t["catch"](2), !e.isUnrecoverableError(t.t0)) {
                  t.next = 12;
                  break;
                }
                return t.abrupt("return", Promise.reject(t.t0));
              case 12:
                return r++, t.next = 15, new Promise(function (t) {
                  return setTimeout(t, e.timeoutForAttempt(r));
                });
              case 15:
                t.next = 1;
                break;
              case 17:
              case "end":
                return t.stop();
            }
          }, t, this, [[2, 8]]);
        }));
      }, this.timeout = null, this._subscriptionService.subscribeToState(this._onDataChange);
    }
    return a(e, [{
      key: "performBackgroundRefresh",
      value: function value() {
        var e = this;
        this._reauthenticateWithBackoff().then(function () {
          e.scheduleBackgroundRefresh();
        })["catch"](function (t) {
          Q("Session background refresh failed. Signalling to app that user is logged out.", {
            error: t
          }), e._subscriptionService.destroyState();
        });
      }
    }, {
      key: "scheduleBackgroundRefresh",
      value: function value() {
        var t = this;
        this.cancelBackgroundRefresh(), this.timeout = setTimeout(function () {
          t.performBackgroundRefresh();
        }, e.REFRESH_INTERVAL_MS);
      }
    }, {
      key: "cancelBackgroundRefresh",
      value: function value() {
        null !== this.timeout && (clearTimeout(this.timeout), this.timeout = null);
      }
    }], [{
      key: "timeoutForAttempt",
      value: function value(e) {
        return e = Math.min(e, 7), Math.floor(350 * Math.random()) - 175 + 2e3 * Math.pow(2, e);
      }
    }, {
      key: "isUnrecoverableError",
      value: function value(e) {
        return F.includes(e.error_type);
      }
    }]), e;
  }();
We.REFRESH_INTERVAL_MS = 18e4;
var qe = "bootstrap";
var Ge = /*#__PURE__*/function () {
  function Ge(e, t, r) {
    var _this = this;
    _classCallCheck(this, Ge);
    this._publicToken = e, this._networkClient = t, this._dataLayer = r, this._bootstrapDataPromise = this._networkClient.fetchSDK({
      url: "/projects/bootstrap/".concat(this._publicToken),
      method: "GET",
      errorMessage: "Error fetching bootstrap data for SDK for ".concat(this._publicToken)
    }).then(Ge.mapBootstrapData).then(function (e) {
      return _this._dataLayer.setItem(qe, JSON.stringify(e)), e;
    })["catch"](function (e) {
      return ee(e), {
        displayWatermark: !1,
        cnameDomain: null,
        emailDomains: ["stytch.com"],
        captchaSettings: {
          enabled: !1
        },
        pkceRequiredForEmailMagicLinks: !1,
        pkceRequiredForPasswordResets: !1,
        pkceRequiredForOAuth: !1,
        pkceRequiredForSso: !1,
        slugPattern: null,
        createOrganizationEnabled: !1,
        passwordConfig: null,
        runDFPProtectedAuth: !1
      };
    });
  }
  _createClass(Ge, [{
    key: "getSync",
    value: function getSync() {
      var e = this._dataLayer.getItem(qe);
      if (null === e) return {
        displayWatermark: !1,
        cnameDomain: null,
        emailDomains: ["stytch.com"],
        captchaSettings: {
          enabled: !1
        },
        pkceRequiredForEmailMagicLinks: !1,
        pkceRequiredForPasswordResets: !1,
        pkceRequiredForOAuth: !1,
        pkceRequiredForSso: !1,
        slugPattern: null,
        createOrganizationEnabled: !1,
        passwordConfig: null,
        runDFPProtectedAuth: !1
      };
      try {
        return JSON.parse(e);
      } catch (e) {
        return {
          displayWatermark: !1,
          cnameDomain: null,
          emailDomains: ["stytch.com"],
          captchaSettings: {
            enabled: !1
          },
          pkceRequiredForEmailMagicLinks: !1,
          pkceRequiredForPasswordResets: !1,
          pkceRequiredForOAuth: !1,
          pkceRequiredForSso: !1,
          slugPattern: null,
          createOrganizationEnabled: !1,
          passwordConfig: null,
          runDFPProtectedAuth: !1
        };
      }
    }
  }, {
    key: "getAsync",
    value: function getAsync() {
      return this._bootstrapDataPromise;
    }
  }], [{
    key: "mapBootstrapData",
    value: function mapBootstrapData(e) {
      var t;
      var r = null !== e.password_config ? {
        ludsComplexity: e.password_config.luds_complexity,
        ludsMinimumCount: e.password_config.luds_minimum_count
      } : null;
      return {
        displayWatermark: !e.disable_sdk_watermark,
        captchaSettings: e.captcha_settings,
        cnameDomain: e.cname_domain,
        emailDomains: e.email_domains,
        pkceRequiredForEmailMagicLinks: e.pkce_required_for_email_magic_links,
        pkceRequiredForPasswordResets: e.pkce_required_for_password_resets,
        pkceRequiredForOAuth: e.pkce_required_for_oauth,
        pkceRequiredForSso: e.pkce_required_for_sso,
        slugPattern: e.slug_pattern,
        createOrganizationEnabled: e.create_organization_enabled,
        passwordConfig: r,
        runDFPProtectedAuth: null !== (t = e.dfp_protected_auth_enabled) && void 0 !== t && t,
        dfpProtectedAuthMode: e.dfp_protected_auth_mode
      };
    }
  }]);
  return Ge;
}();
function He(e, t, r, n) {
  return new (r || (r = Promise))(function (i, s) {
    function o(e) {
      try {
        c(n.next(e));
      } catch (e) {
        s(e);
      }
    }
    function a(e) {
      try {
        c(n["throw"](e));
      } catch (e) {
        s(e);
      }
    }
    function c(e) {
      var t;
      e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
        e(t);
      })).then(o, a);
    }
    c((n = n.apply(e, t || [])).next());
  });
}
"function" == typeof SuppressedError && SuppressedError;
var Ye = /*#__PURE__*/_createClass(function Ye(e) {
  var _this2 = this;
  _classCallCheck(this, Ye);
  this.bootstrapPromise = e, this.executeRecaptcha = function () {
    return He(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _yield$this$state, e, t, r;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return this.state;
          case 2:
            _yield$this$state = _context.sent;
            e = _yield$this$state.captchaClient;
            t = _yield$this$state.configured;
            r = _yield$this$state.siteKey;
            if (!t) {
              _context.next = 10;
              break;
            }
            _context.next = 9;
            return new Promise(function (t) {
              return e.ready(t);
            });
          case 9:
            return _context.abrupt("return", e.execute(r, {
              action: "LOGIN"
            }));
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
  }, this.state = e.then(function (e) {
    return He(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var t;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!e.captchaSettings.enabled) {
              _context2.next = 9;
              break;
            }
            _context2.t1 = !0;
            _context2.next = 4;
            return t = e.captchaSettings.siteKey, V("https://www.google.com/recaptcha/enterprise.js?render=".concat(t), function () {
              return window.grecaptcha.enterprise;
            });
          case 4:
            _context2.t2 = _context2.sent;
            _context2.t3 = e.captchaSettings.siteKey;
            _context2.t0 = {
              configured: _context2.t1,
              captchaClient: _context2.t2,
              siteKey: _context2.t3
            };
            _context2.next = 10;
            break;
          case 9:
            _context2.t0 = {
              configured: !1
            };
          case 10:
            return _context2.abrupt("return", _context2.t0);
          case 11:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
  });
});
var ze = /*#__PURE__*/function () {
  function ze(e) {
    var _this3 = this;
    _classCallCheck(this, ze);
    this.iframeURL = e, this.oneTapStart = function (e) {
      return _this3.call("oneTapStart", e);
    }, this.oneTapSubmit = function (e) {
      return _this3.call("oneTapSubmit", e);
    };
  }
  _createClass(ze, [{
    key: "frameClient",
    get: function get() {
      var e;
      return this._frameClient = null !== (e = this._frameClient) && void 0 !== e ? e : new Ke(this.iframeURL), this._frameClient;
    }
  }, {
    key: "call",
    value: function call(e, t) {
      return this.frameClient.call(e, [t]);
    }
  }]);
  return ze;
}();
function Ve(e) {
  return Ve = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
    return _typeof(e);
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
  }, Ve(e);
}
function Je(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (i = n.key, s = void 0, s = function (e, t) {
      if ("object" !== Ve(e) || null === e) return e;
      var r = e[Symbol.toPrimitive];
      if (void 0 !== r) {
        var n = r.call(e, t || "default");
        if ("object" !== Ve(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(i, "string"), "symbol" === Ve(s) ? s : String(s)), n);
  }
  var i, s;
}
function $e(e, t, r) {
  return t && Je(e.prototype, t), r && Je(e, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Xe(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Ze(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && it(e, t);
}
function Qe(e) {
  var t = nt();
  return function () {
    var r,
      n = st(e);
    if (t) {
      var i = st(this).constructor;
      r = Reflect.construct(n, arguments, i);
    } else r = n.apply(this, arguments);
    return function (e, t) {
      if (t && ("object" === Ve(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return et(e);
    }(this, r);
  };
}
function et(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function tt(e) {
  var t = "function" == typeof Map ? new Map() : void 0;
  return tt = function tt(e) {
    if (null === e || (r = e, -1 === Function.toString.call(r).indexOf("[native code]"))) return e;
    var r;
    if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== t) {
      if (t.has(e)) return t.get(e);
      t.set(e, n);
    }
    function n() {
      return rt(e, arguments, st(this).constructor);
    }
    return n.prototype = Object.create(e.prototype, {
      constructor: {
        value: n,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), it(n, e);
  }, tt(e);
}
function rt(e, t, r) {
  return rt = nt() ? Reflect.construct.bind() : function (e, t, r) {
    var n = [null];
    n.push.apply(n, t);
    var i = new (Function.bind.apply(e, n))();
    return r && it(i, r.prototype), i;
  }, rt.apply(null, arguments);
}
function nt() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}
function it(e, t) {
  return it = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, it(e, t);
}
function st(e) {
  return st = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, st(e);
}
var ot, at, ct, ut, lt, dt;
!function (e) {
  e.emailMagicLinks = "emailMagicLinks", e.oauth = "oauth", e.otp = "otp", e.crypto = "crypto", e.passwords = "passwords", e.passkeys = "passkeys";
}(ot || (ot = {})), function (e) {
  e.Google = "google", e.Microsoft = "microsoft", e.Apple = "apple", e.Github = "github", e.GitLab = "gitlab", e.Facebook = "facebook", e.Discord = "discord", e.Salesforce = "salesforce", e.Slack = "slack", e.Amazon = "amazon", e.Bitbucket = "bitbucket", e.LinkedIn = "linkedin", e.Coinbase = "coinbase", e.Twitch = "twitch", e.Twitter = "twitter", e.TikTok = "tiktok", e.Snapchat = "snapchat", e.Figma = "figma", e.Yahoo = "yahoo";
}(at || (at = {})), function (e) {
  e.Vessel = "Vessel", e.Phantom = "Phantom", e.Metamask = "Metamask", e.Coinbase = "Coinbase", e.Binance = "Binance", e.GenericEthereumWallet = "Other Ethereum Wallet", e.GenericSolanaWallet = "Other Solana Wallet";
}(ct || (ct = {})), function (e) {
  e.embedded = "embedded", e.floating = "floating";
}(ut || (ut = {})), function (e) {
  e.SMS = "sms", e.WhatsApp = "whatsapp", e.Email = "email";
}(lt || (lt = {})), function (e) {
  e.MagicLinkLoginOrCreateEvent = "MAGIC_LINK_LOGIN_OR_CREATE", e.OTPsLoginOrCreateEvent = "OTP_LOGIN_OR_CREATE", e.OTPsAuthenticate = "OTP_AUTHENTICATE", e.CryptoWalletAuthenticateStart = "CRYPTO_WALLET_AUTHENTICATE_START", e.CryptoWalletAuthenticate = "CRYPTO_WALLET_AUTHENTICATE", e.PasswordCreate = "PASSWORD_CREATE", e.PasswordAuthenticate = "PASSWORD_AUTHENTICATE", e.PasswordResetByEmailStart = "PASSWORD_RESET_BY_EMAIL_START", e.PasswordResetByEmail = "PASSWORD_RESET_BY_EMAIL", e.PasskeyRegister = "PASSKEY_REGISTER", e.PasskeyAuthenticate = "PASSKEY_AUTHENTICATE", e.PasskeySkip = "PASSKEY_SKIP", e.PasskeyDone = "PASSKEY_DONE", e.B2BMagicLinkEmailLoginOrSignup = "B2B_MAGIC_LINK_EMAIL_LOGIN_OR_SIGNUP", e.B2BMagicLinkAuthenticate = "B2B_MAGIC_LINK_AUTHENTICATE", e.B2BMagicLinkEmailDiscoverySend = "B2B_MAGIC_LINK_EMAIL_DISCOVERY_SEND", e.B2BMagicLinkDiscoveryAuthenticate = "B2B_MAGIC_LINK_DISCOVERY_AUTHENTICATE", e.B2BSSOStart = "B2B_SSO_START", e.B2BSSOAuthenticate = "B2B_SSO_AUTHENTICATE", e.B2BOAuthAuthenticate = "B2B_SSO_AUTHENTICATE", e.B2BOAuthDiscoveryAuthenticate = "B2B_OAUTH_DISCOVERY_AUTHENTICATE", e.B2BDiscoveryOrganizationsCreate = "B2B_DISCOVERY_ORGANIZATIONS_CREATE", e.B2BDiscoveryIntermediateSessionExchange = "B2B_DISCOVERY_INTERMEDIATE_SESSION_EXCHANGE", e.B2BPasswordAuthenticate = "B2B_PASSWORD_AUTHENTICATE", e.B2BPasswordResetByEmailStart = "B2B_PASSWORD_RESET_BY_EMAIL_START", e.B2BPasswordResetByEmail = "B2B_PASSWORD_RESET_BY_EMAIL", e.B2BPasswordResetBySession = "B2B_PASSWORD_RESET_BY_SESSION";
}(dt || (dt = {}));
var ht,
  pt,
  ft,
  _t,
  mt = function (e) {
    Ze(r, tt(Error));
    var t = Qe(r);
    function r(e, n) {
      var i;
      return Xe(this, r), (i = t.call(this, e + "\n" + n)).message = e + "\n" + n, i.name = "SDKAPIUnreachableError", i.details = n, Object.setPrototypeOf(et(i), r.prototype), i;
    }
    return $e(r);
  }(),
  vt = function (e) {
    Ze(r, tt(Error));
    var t = Qe(r);
    function r(e, n) {
      var i;
      return Xe(this, r), (i = t.call(this)).name = "StytchSDKUsageError", i.message = "Invalid call to ".concat(e, "\n") + n, i;
    }
    return $e(r);
  }(),
  yt = function (e) {
    Ze(r, tt(Error));
    var t = Qe(r);
    function r(e) {
      var n, i;
      Xe(this, r), (n = t.call(this)).name = "StytchSDKSchemaError";
      var s = null === (i = e.body) || void 0 === i ? void 0 : i.map(function (e) {
        return "".concat(e.dataPath, ": ").concat(e.message);
      }).join("\n");
      return n.message = "[400] Request does not match expected schema\n".concat(s), n;
    }
    return $e(r);
  }(),
  gt = function (e) {
    Ze(r, tt(Error));
    var t = Qe(r);
    function r(e) {
      var n;
      Xe(this, r), (n = t.call(this)).name = "StytchSDKAPIError";
      var i = e.status_code,
        s = e.error_type,
        o = e.error_message,
        a = e.error_url,
        c = e.request_id;
      return n.error_type = s, n.error_message = o, n.error_url = a, n.request_id = c, n.status_code = i, n.message = "[".concat(i, "] ").concat(s, "\n") + "".concat(o, "\n") + "See ".concat(a, " for more information.\n") + (c ? "request_id: ".concat(c, "\n") : ""), n;
    }
    return $e(r);
  }(),
  bt = function (e) {
    Ze(r, tt(Error));
    var t = Qe(r);
    function r(e) {
      var n;
      return Xe(this, r), (n = t.call(this)).name = "StytchSDKNativeError", n.error_type = e, n.message = "".concat(e), n;
    }
    return $e(r);
  }(),
  kt = ["unauthorized_credentials", "user_unauthenticated", "invalid_secret_authentication", "session_not_found"];
!function (e) {
  e.BiometricsSensorError = "biometrics_sensor_error", e.DeviceCredentialsNotAllowed = "device_credentials_not_allowed", e.DeviceHardwareError = "device_hardware_error", e.InternalError = "internal_error", e.KeyInvalidated = "key_invalidated", e.KeystoreUnavailable = "keystore_unavailable", e.NoBiometricsEnrolled = "no_biometrics_enrolled", e.NoBiometricsRegistration = "no_biometrics_registration", e.SessionExpired = "session_expired", e.UserCancellation = "user_cancellation", e.UserLockedOut = "user_locked_out", e.BiometricsNotAvailable = "biometrics_not_available";
}(ht || (ht = {})), function (e) {
  e.emailMagicLinks = "emailMagicLinks", e.sso = "sso", e.passwords = "passwords", e.oauth = "oauth";
}(pt || (pt = {})), function (e) {
  e.Discovery = "Discovery", e.Organization = "Organization", e.PasswordReset = "PasswordReset";
}(ft || (ft = {})), function (e) {
  e.Google = "google", e.Microsoft = "microsoft";
}(_t || (_t = {}));
var wt = /*#__PURE__*/function (_fe) {
  _inherits(wt, _fe);
  var _super = _createSuper(wt);
  function wt(e, t, r, n, i, s) {
    var _this4;
    _classCallCheck(this, wt);
    _this4 = _super.call(this, e, t, r, n, i), _this4._oneTap = s, _this4.startOneTap = function (e) {
      return He(_assertThisInitialized(_this4), void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var t, r, n;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this._oneTap.createOneTapClient();
            case 2:
              t = _context3.sent;
              if (t.success) {
                _context3.next = 5;
                break;
              }
              throw new Error("One Tap could not load: ".concat(t.reason));
            case 5:
              r = t.client, n = this._oneTap.createOnSuccessHandler({
                signupRedirectUrl: e.signup_redirect_url,
                loginRedirectUrl: e.login_redirect_url,
                onSuccess: this._oneTap.RedirectOnSuccess
              });
              return _context3.abrupt("return", r.render({
                style: {
                  position: ut.floating
                },
                onOneTapCancelled: e.onOneTapCancelled,
                callback: n
              }));
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }, _this4.googleOneTap = {
      start: _this4.startOneTap
    };
    return _this4;
  }
  return _createClass(wt);
}(fe);
var St = /*#__PURE__*/function () {
  function St(e, t, r, n) {
    _classCallCheck(this, St);
    this._publicToken = e, this._subscriptionDataLayer = t, this.baseURL = r, this.additionalTelemetryDataFn = n, this.updateSessionToken = function () {
      return null;
    }, this.eventLogger = new ce({
      maxBatchSize: 15,
      intervalDurationMs: 800,
      logEventURL: this.buildSDKUrl("/events")
    });
  }
  _createClass(St, [{
    key: "logEvent",
    value: function logEvent(_ref) {
      var e = _ref.name,
        t = _ref.details,
        _ref$error = _ref.error,
        r = _ref$error === void 0 ? {} : _ref$error;
      this.eventLogger.logEvent(this.createTelemetryBlob(), {
        public_token: this._publicToken,
        event_name: e,
        details: t,
        error_code: r.error_code,
        error_description: r.error_description,
        http_status_code: r.http_status_code
      });
    }
  }, {
    key: "createTelemetryBlob",
    value: function createTelemetryBlob() {
      return Object.assign(Object.assign({
        event_id: "event-id-".concat(Y()),
        app_session_id: "app-session-id-".concat(Y()),
        persistent_id: "persistent-id-".concat(Y()),
        client_sent_at: new Date().toISOString(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
      }, this.additionalTelemetryDataFn()), {
        app: {
          identifier: window.location.hostname
        },
        sdk: {
          identifier: "Stytch.js Javascript SDK",
          version: "3.1.1"
        }
      });
    }
  }, {
    key: "fetchSDK",
    value: function fetchSDK(_ref2) {
      var e = _ref2.url,
        t = _ref2.body,
        r = _ref2.errorMessage,
        n = _ref2.method;
      return He(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var i, s, o, a;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              i = this._subscriptionDataLayer.readSessionCookie().session_token, s = "Basic " + window.btoa(this._publicToken + ":" + (i || this._publicToken)), o = window.btoa(JSON.stringify(this.createTelemetryBlob())), a = window.location.origin;
              return _context4.abrupt("return", N({
                basicAuthHeader: s,
                body: t,
                errorMessage: r,
                finalURL: this.buildSDKUrl(e),
                method: n,
                xSDKClientHeader: o,
                xSDKParentHostHeader: a
              }));
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "retriableFetchSDK",
    value: function retriableFetchSDK(_ref3) {
      var e = _ref3.url,
        t = _ref3.body,
        r = _ref3.errorMessage,
        n = _ref3.method,
        i = _ref3.retryCallback;
      return He(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var o, a, c, u;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              o = this._subscriptionDataLayer.readSessionCookie().session_token, a = "Basic " + window.btoa(this._publicToken + ":" + (o || this._publicToken)), c = window.btoa(JSON.stringify(this.createTelemetryBlob())), u = window.location.origin;
              return _context5.abrupt("return", function (e) {
                var t = e.method,
                  r = e.errorMessage,
                  n = e.finalURL,
                  i = e.basicAuthHeader,
                  o = e.xSDKClientHeader,
                  a = e.xSDKParentHostHeader,
                  c = e.body,
                  u = e.retryCallback;
                return T(this, void 0, void 0, s().mark(function e() {
                  var l;
                  return s().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        return l = {
                          method: t,
                          errorMessage: r,
                          finalURL: n,
                          basicAuthHeader: i,
                          xSDKClientHeader: o,
                          xSDKParentHostHeader: a,
                          body: c
                        }, e.prev = 1, e.next = 4, N(l);
                      case 4:
                      case 15:
                        return e.abrupt("return", e.sent);
                      case 7:
                        if (e.prev = 7, e.t0 = e["catch"](1), !(e.t0 instanceof M)) {
                          e.next = 16;
                          break;
                        }
                        return e.next = 12, u(e.t0, l);
                      case 12:
                        return l = e.sent, e.next = 15, N(l);
                      case 16:
                        throw e.t0;
                      case 17:
                      case "end":
                        return e.stop();
                    }
                  }, e, null, [[1, 7]]);
                }));
              }({
                basicAuthHeader: a,
                body: t,
                errorMessage: r,
                finalURL: this.buildSDKUrl(e),
                method: n,
                xSDKClientHeader: c,
                xSDKParentHostHeader: u,
                retryCallback: i
              }));
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "buildSDKUrl",
    value: function buildSDKUrl(e) {
      return "".concat(this.baseURL, "/sdk/v1").concat(e);
    }
  }]);
  return St;
}();
var Ct = /*#__PURE__*/function () {
  function Ct(e, t, r) {
    _classCallCheck(this, Ct);
    this._googleClient = e, this._publicToken = t, this._clientId = r;
  }
  _createClass(Ct, [{
    key: "cancel",
    value: function cancel() {
      this._googleClient.cancel();
    }
  }, {
    key: "render",
    value: function render(_ref4) {
      var e = _ref4.callback,
        t = _ref4.onOneTapCancelled,
        r = _ref4.style;
      return He(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this5 = this;
        var n;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              n = {
                client_id: this._clientId,
                callback: e,
                auto_select: !1,
                context: "use",
                itp_support: !0
              };
              return _context6.abrupt("return", (r.position === ut.embedded && (n.prompt_parent_id = "google-parent-prompt", n.cancel_on_tap_outside = !1), this._googleClient.initialize(n), new Promise(function (e) {
                _this5._googleClient.prompt(function (n) {
                  return n.isSkippedMoment() ? ("user_cancel" === n.getSkippedReason() && (null == t || t()), e({
                    success: !1,
                    reason: n.getSkippedReason()
                  })) : n.isNotDisplayed() ? e({
                    success: !1,
                    reason: n.getNotDisplayedReason()
                  }) : (_this5.styleFrame(r), e({
                    success: !0
                  }));
                });
              })));
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "styleFrame",
    value: function styleFrame(e) {
      e.position === ut.embedded && Array.from(document.getElementsByTagName("iframe")).forEach(function (e) {
        e.src.includes(S) && (e.style.width = "100%");
      });
    }
  }]);
  return Ct;
}();
var At = /*#__PURE__*/function () {
  function At(e, t) {
    var _this6 = this;
    _classCallCheck(this, At);
    this._publicToken = e, this.clientsideServices = t, this.createOnSuccessHandler = function (_ref5) {
      var e = _ref5.loginRedirectUrl,
        t = _ref5.signupRedirectUrl,
        r = _ref5.onSuccess;
      return function (n) {
        return He(_this6, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
          var i, _yield$this$submitGoo, s;
          return _regeneratorRuntime().wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                i = n.credential;
                _context7.next = 3;
                return this.submitGoogleOneTapToken({
                  credential: i,
                  loginRedirectUrl: e,
                  signupRedirectUrl: t
                });
              case 3:
                _yield$this$submitGoo = _context7.sent;
                s = _yield$this$submitGoo.redirect_url;
                r(s);
              case 6:
              case "end":
                return _context7.stop();
            }
          }, _callee7, this);
        }));
      };
    }, this.RedirectOnSuccess = function (e) {
      window.location.href = e;
    };
  }
  _createClass(At, [{
    key: "createOneTapClient",
    value: function createOneTapClient() {
      return He(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var e, _yield$this$fetchGoog;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _context8.next = 3;
              return this.fetchGoogleStart();
            case 3:
              _yield$this$fetchGoog = _context8.sent;
              e = _yield$this$fetchGoog.googleClientId;
              _context8.next = 10;
              break;
            case 7:
              _context8.prev = 7;
              _context8.t0 = _context8["catch"](0);
              return _context8.abrupt("return", {
                success: !1,
                reason: _context8.t0.error_type
              });
            case 10:
              if (!("" === e)) {
                _context8.next = 12;
                break;
              }
              return _context8.abrupt("return", {
                success: !1,
                reason: "oauth_config_not_found"
              });
            case 12:
              _context8.t1 = !0;
              _context8.t2 = Ct;
              _context8.next = 16;
              return V(C, function () {
                return window.google.accounts.id;
              });
            case 16:
              _context8.t3 = _context8.sent;
              _context8.t4 = this._publicToken;
              _context8.t5 = e;
              _context8.t6 = new _context8.t2(_context8.t3, _context8.t4, _context8.t5);
              return _context8.abrupt("return", {
                success: _context8.t1,
                client: _context8.t6
              });
            case 21:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[0, 7]]);
      }));
    }
  }, {
    key: "fetchGoogleStart",
    value: function fetchGoogleStart() {
      return this.googleConfig || (this.googleConfig = this.clientsideServices.oneTapStart({
        publicToken: this._publicToken
      })), this.googleConfig;
    }
  }, {
    key: "submitGoogleOneTapToken",
    value: function submitGoogleOneTapToken(_ref6) {
      var e = _ref6.credential,
        t = _ref6.loginRedirectUrl,
        r = _ref6.signupRedirectUrl;
      return He(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _yield$this$fetchGoog2, n;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.fetchGoogleStart();
            case 2:
              _yield$this$fetchGoog2 = _context9.sent;
              n = _yield$this$fetchGoog2.oauthCallbackId;
              return _context9.abrupt("return", this.clientsideServices.oneTapSubmit({
                publicToken: this._publicToken,
                idToken: e,
                loginRedirectURL: t,
                oauthCallbackID: n,
                signupRedirectURL: r
              }));
            case 5:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
    }
  }], [{
    key: "WillGoogleOneTapShowBannerForUA",
    value: function WillGoogleOneTapShowBannerForUA(e) {
      var t = function t(e, _t2) {
          return -1 !== e.indexOf(_t2);
        },
        r = t(e, "iPad") || t(e, "Android") && !t(e, "Mobile") || t(e, "Silk"),
        n = t(e, "iPod") || t(e, "iPhone") || t(e, "Android") || t(e, "IEMobile");
      return !r && n;
    }
  }, {
    key: "WillGoogleOneTapShowEmbedded",
    value: function WillGoogleOneTapShowEmbedded() {
      return !At.WillGoogleOneTapShowBannerForUA(navigator.userAgent);
    }
  }]);
  return At;
}();
function Tt(e) {
  var t = e.toString(16);
  return 1 === t.length && (t = "0" + t), t;
}
var Ot = /*#__PURE__*/function () {
  function Ot(e, t) {
    _classCallCheck(this, Ot);
    this._dataLayer = e, this.namespace = t;
  }
  _createClass(Ot, [{
    key: "key",
    value: function key() {
      return "PKCE_VERIFIER:" + this.namespace;
    }
  }, {
    key: "startPKCETransaction",
    value: function startPKCETransaction() {
      return He(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var e;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return Ot.createProofkeyPair();
            case 2:
              e = _context10.sent;
              return _context10.abrupt("return", (this._dataLayer.setItem(this.key(), JSON.stringify(e)), e));
            case 4:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "getPKPair",
    value: function getPKPair() {
      var e = this._dataLayer.getItem(this.key());
      if (null !== e) try {
        return JSON.parse(e);
      } catch (e) {
        return void Q("Found malformed Proof Key pair in localstorage.");
      }
    }
  }, {
    key: "clearPKPair",
    value: function clearPKPair() {
      return this._dataLayer.removeItem(this.key());
    }
  }], [{
    key: "createProofkeyPair",
    value: function createProofkeyPair() {
      return He(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var _String$fromCharCode;
        var e, t, r, n;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              e = new Uint32Array(16);
              window.crypto.getRandomValues(e);
              t = Array.from(e).map(Tt).join("");
              _context11.next = 5;
              return window.crypto.subtle.digest("SHA-256", new TextEncoder().encode(t));
            case 5:
              r = _context11.sent;
              return _context11.abrupt("return", {
                code_challenge: (n = r, btoa((_String$fromCharCode = String.fromCharCode).call.apply(_String$fromCharCode, [null].concat(_toConsumableArray(new Uint8Array(n))))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "")),
                code_verifier: t
              });
            case 7:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }));
    }
  }]);
  return Ot;
}();
var Et = /*#__PURE__*/function () {
  function Et(e) {
    _classCallCheck(this, Et);
    this._networkClient = e;
  }
  _createClass(Et, [{
    key: "searchUser",
    value: function searchUser(e) {
      return this._networkClient.fetchSDK({
        url: "/users/search",
        method: "POST",
        body: {
          email: e
        },
        errorMessage: "Error searching for user ".concat(e)
      });
    }
  }, {
    key: "searchOrganization",
    value: function searchOrganization(e) {
      return this._networkClient.fetchSDK({
        url: "/b2b/organizations/search",
        method: "POST",
        body: {
          organization_slug: e
        },
        errorMessage: "Error searching slug"
      });
    }
  }, {
    key: "searchMember",
    value: function searchMember(e, t) {
      return this._networkClient.fetchSDK({
        url: "/b2b/organizations/members/search",
        method: "POST",
        body: {
          email_address: e,
          organization_id: t
        },
        errorMessage: "Error searching for member ".concat(e)
      });
    }
  }]);
  return Et;
}();
var Pt = function Pt(e) {
  return (document.cookie ? document.cookie.split("; ") : []).filter(function (t) {
    var _t$split = t.split("="),
      _t$split2 = _slicedToArray(_t$split, 1),
      r = _t$split2[0];
    return e === r;
  }).length > 1;
};
/*! js-cookie v3.0.1 | MIT */
function xt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var n in r) e[n] = r[n];
  }
  return e;
}
var Rt = function e(t, r) {
  function n(e, n, i) {
    if ("undefined" != typeof document) {
      "number" == typeof (i = xt({}, r, i)).expires && (i.expires = new Date(Date.now() + 864e5 * i.expires)), i.expires && (i.expires = i.expires.toUTCString()), e = encodeURIComponent(e).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var s = "";
      for (var o in i) i[o] && (s += "; " + o, !0 !== i[o] && (s += "=" + i[o].split(";")[0]));
      return document.cookie = e + "=" + t.write(n, e) + s;
    }
  }
  return Object.create({
    set: n,
    get: function get(e) {
      if ("undefined" != typeof document && (!arguments.length || e)) {
        for (var r = document.cookie ? document.cookie.split("; ") : [], n = {}, i = 0; i < r.length; i++) {
          var s = r[i].split("="),
            o = s.slice(1).join("=");
          try {
            var a = decodeURIComponent(s[0]);
            if (n[a] = t.read(o, a), e === a) break;
          } catch (e) {}
        }
        return e ? n[e] : n;
      }
    },
    remove: function remove(e, t) {
      n(e, "", xt({}, t, {
        expires: -1
      }));
    },
    withAttributes: function withAttributes(t) {
      return e(this.converter, xt({}, this.attributes, t));
    },
    withConverter: function withConverter(t) {
      return e(xt({}, this.converter, t), this.attributes);
    }
  }, {
    attributes: {
      value: Object.freeze(r)
    },
    converter: {
      value: Object.freeze(t)
    }
  });
}({
  read: function read(e) {
    return '"' === e[0] && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function write(e) {
    return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
  }
}, {
  path: "/"
});
var Dt = function Dt(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return "stytch_sdk_state_".concat(e).concat(t ? "::".concat(t) : "");
};
var It = /*#__PURE__*/function () {
  function It(e, t) {
    var _this7 = this;
    _classCallCheck(this, It);
    this.browserSessionStorage = {
      getItem: function getItem(e) {
        return sessionStorage.getItem(Dt(_this7.publicToken, e));
      },
      setItem: function setItem(e, t) {
        return sessionStorage.setItem(Dt(_this7.publicToken, e), t);
      },
      removeItem: function removeItem(e) {
        return sessionStorage.removeItem(Dt(_this7.publicToken, e));
      }
    }, this.publicToken = e, this.state = null, this.subscriptions = {}, (null == t ? void 0 : t.cookieOptions) ? (re("SubscriptionDataLayer").isOptionalString("cookieOptions.opaqueTokenCookieName", t.cookieOptions.opaqueTokenCookieName).isOptionalString("cookieOptions.jwtCookieName", t.cookieOptions.jwtCookieName).isOptionalString("cookieOptions.istCookieName", t.cookieOptions.istCookieName).isOptionalString("cookieOptions.path", t.cookieOptions.path).isOptionalString("cookieOptions.domain", t.cookieOptions.domain), this._jwtCookieName = t.cookieOptions.jwtCookieName || null, this._opaqueTokenCookieName = t.cookieOptions.opaqueTokenCookieName || null, this._cookiePath = t.cookieOptions.path || null, this._domain = t.cookieOptions.domain || null, this._cookieAvailableToSubdomains = t.cookieOptions.availableToSubdomains || !1, this._istCookieName = t.cookieOptions.istCookieName || null) : (this._opaqueTokenCookieName = null, this._jwtCookieName = null, this._cookiePath = null, this._domain = null, this._cookieAvailableToSubdomains = !1, this._istCookieName = null);
    var r = localStorage.getItem(Dt(this.publicToken));
    if (!r) return;
    var n;
    try {
      n = JSON.parse(r);
    } catch (e) {
      return void this.syncToLocalStorage();
    }
    this.state = n;
  }
  _createClass(It, [{
    key: "opaqueTokenCookieName",
    get: function get() {
      var e;
      return null !== (e = this._opaqueTokenCookieName) && void 0 !== e ? e : "stytch_session";
    }
  }, {
    key: "jwtCookieName",
    get: function get() {
      var e;
      return null !== (e = this._jwtCookieName) && void 0 !== e ? e : "stytch_session_jwt";
    }
  }, {
    key: "istCookieName",
    get: function get() {
      var e;
      return null !== (e = this._istCookieName) && void 0 !== e ? e : "stytch_intermediate_session_token";
    }
  }, {
    key: "readSessionCookie",
    value: function readSessionCookie() {
      return {
        session_token: Rt.get(this.opaqueTokenCookieName),
        session_jwt: Rt.get(this.jwtCookieName)
      };
    }
  }, {
    key: "readIntermediateSessionTokenCookie",
    value: function readIntermediateSessionTokenCookie() {
      return Rt.get(this.istCookieName);
    }
  }, {
    key: "writeSessionCookie",
    value: function writeSessionCookie(e) {
      var t, r, n, i;
      var s = e.state,
        o = e.session_token,
        a = e.session_jwt,
        c = It.generateCookieOpts({
          expiresAt: null !== (r = null === (t = null == s ? void 0 : s.session) || void 0 === t ? void 0 : t.expires_at) && void 0 !== r ? r : "",
          availableToSubdomains: this._cookieAvailableToSubdomains,
          path: this._cookiePath,
          domain: this._domain
        });
      Rt.set(this.opaqueTokenCookieName, o, c), Rt.set(this.jwtCookieName, a, c);
      var u = It.generateCookieOpts({
        expiresAt: null !== (i = null === (n = null == s ? void 0 : s.session) || void 0 === n ? void 0 : n.expires_at) && void 0 !== i ? i : "",
        availableToSubdomains: !this._cookieAvailableToSubdomains,
        path: this._cookiePath,
        domain: this._domain
      });
      Pt(this.jwtCookieName) && Rt.remove(this.jwtCookieName, u), Pt(this.opaqueTokenCookieName) && Rt.remove(this.opaqueTokenCookieName, u), Pt(this.jwtCookieName) && Q("Could not remove extraneous JWT cookie. This might happen if the cookie has been set using multiple `path` settings, and may produce unwanted behavior."), Pt(this.opaqueTokenCookieName) && Q("Could not remove extraneous opaque token cookie.");
    }
  }, {
    key: "writeIntermediateSessionTokenCookie",
    value: function writeIntermediateSessionTokenCookie(e) {
      var t = new Date(Date.now() + 6e5),
        r = It.generateCookieOpts({
          expiresAt: t.toString(),
          availableToSubdomains: this._cookieAvailableToSubdomains,
          path: this._cookiePath,
          domain: this._domain
        });
      Rt.set(this.istCookieName, e, r);
    }
  }, {
    key: "removeSessionCookie",
    value: function removeSessionCookie() {
      this.removeCookies([this.opaqueTokenCookieName, this.jwtCookieName]);
    }
  }, {
    key: "removeISTCookie",
    value: function removeISTCookie() {
      this.removeCookies([this.istCookieName]);
    }
  }, {
    key: "removeCookies",
    value: function removeCookies(e) {
      var _this8 = this;
      [!0, !1].forEach(function (t) {
        [_this8._cookiePath, null].forEach(function (r) {
          [_this8._domain, null].forEach(function (n) {
            var i = It.generateCookieOpts({
              expiresAt: new Date(0).toString(),
              availableToSubdomains: t,
              path: r,
              domain: n
            });
            e.forEach(function (e) {
              Rt.remove(e, i);
            });
          });
        });
      });
    }
  }, {
    key: "syncToLocalStorage",
    value: function syncToLocalStorage() {
      localStorage.setItem(Dt(this.publicToken), JSON.stringify(this.state));
    }
  }, {
    key: "getItem",
    value: function getItem(e) {
      return localStorage.getItem(Dt(this.publicToken, e));
    }
  }, {
    key: "setItem",
    value: function setItem(e, t) {
      return localStorage.setItem(Dt(this.publicToken, e), t);
    }
  }, {
    key: "removeItem",
    value: function removeItem(e) {
      return localStorage.removeItem(Dt(this.publicToken, e));
    }
  }], [{
    key: "generateCookieOpts",
    value: function generateCookieOpts(_ref7) {
      var e = _ref7.path,
        t = _ref7.domain,
        r = _ref7.availableToSubdomains,
        n = _ref7.expiresAt;
      var i = {
        expires: new Date(n),
        sameSite: "lax"
      };
      return e && (i.path = e), Boolean("localhost" === window.location.hostname || "[::1]" === window.location.hostname || window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)) ? i.secure = !1 : (r && (i.domain = t || window.location.host), i.secure = !0), i;
    }
  }]);
  return It;
}();
var Bt = /*#__PURE__*/function (_It) {
  _inherits(Bt, _It);
  var _super2 = _createSuper(Bt);
  function Bt() {
    _classCallCheck(this, Bt);
    return _super2.apply(this, arguments);
  }
  return _createClass(Bt);
}(It);
var Lt = Symbol["for"]("__stytch_DataLayer"),
  Ft = function Ft(e, t) {
    var r = function () {
      var e = window;
      return e[Lt] || (e[Lt] = {}), e[Lt];
    }();
    return r[e] || (r[e] = new Bt(e, t)), r[e];
  },
  jt = function jt(e, t) {
    Object.values(e).forEach(function (e) {
      return e(t);
    });
  },
  Mt = function () {
    var e = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).KEYS_TO_EXCLUDE,
      r = void 0 === e ? [] : e;
    return function e(n, s) {
      return i(n) === i(s) && (null === n || null === s ? n === s : "object" === i(n) ? Object.keys(n).length === Object.keys(s).length && !Object.keys(n).some(function (e) {
        return !(e in s);
      }) && Object.entries(n).filter(function (e) {
        var n = t(e, 1)[0];
        return !r.includes(n);
      }).every(function (r) {
        var n = t(r, 2),
          i = n[0],
          o = n[1];
        return e(o, s[i]);
      }) : n === s);
    };
  }({
    KEYS_TO_EXCLUDE: ["last_accessed_at"]
  });
var Nt = /*#__PURE__*/function () {
  function Nt(e, t) {
    var _this9 = this;
    _classCallCheck(this, Nt);
    this._publicToken = e, this._datalayer = t, this._listen = function (e) {
      if (e.key !== Dt(_this9._publicToken)) return;
      if (null === e.newValue || "null" === e.newValue) return void _this9.destroyState();
      var t = JSON.parse(e.newValue);
      _this9.updateState(t);
    }, window.addEventListener("storage", this._listen);
    var _this$_datalayer$read = this._datalayer.readSessionCookie(),
      r = _this$_datalayer$read.session_token;
    r || this.destroyState();
  }
  _createClass(Nt, [{
    key: "getTokens",
    value: function getTokens() {
      var _this$_datalayer$read2 = this._datalayer.readSessionCookie(),
        e = _this$_datalayer$read2.session_token,
        t = _this$_datalayer$read2.session_jwt;
      return "string" != typeof e || "string" != typeof t ? null : {
        session_token: e,
        session_jwt: t
      };
    }
  }, {
    key: "getIntermediateSessionToken",
    value: function getIntermediateSessionToken() {
      return this._datalayer.readIntermediateSessionTokenCookie() || null;
    }
  }, {
    key: "destroyState",
    value: function destroyState() {
      this.updateStateAndTokens({
        state: null,
        session_token: null,
        session_jwt: null,
        intermediate_session_token: null
      });
    }
  }, {
    key: "_updateStateAndTokensInternal",
    value: function _updateStateAndTokensInternal(e) {
      var t = this._datalayer.state,
        r = null === e.state ? null : Object.assign(Object.assign({}, this._datalayer.state), e.state);
      this._datalayer.state = r, Mt(t, r) || jt(this._datalayer.subscriptions, r);
    }
  }, {
    key: "updateStateAndTokens",
    value: function updateStateAndTokens(e) {
      e.state ? (this._datalayer.writeSessionCookie(e), this._datalayer.removeISTCookie()) : e.intermediate_session_token ? (this._datalayer.writeIntermediateSessionTokenCookie(e.intermediate_session_token), this._datalayer.removeSessionCookie()) : (this._datalayer.removeSessionCookie(), this._datalayer.removeISTCookie()), this._updateStateAndTokensInternal(e), this._datalayer.syncToLocalStorage();
    }
  }, {
    key: "updateState",
    value: function updateState(e) {
      var t = this._datalayer.state,
        r = null === e ? null : Object.assign(Object.assign({}, this._datalayer.state), e);
      this._datalayer.state = r, Mt(t, r) || (jt(this._datalayer.subscriptions, r), this._datalayer.syncToLocalStorage());
    }
  }, {
    key: "updateTokens",
    value: function updateTokens(e) {
      var t = e.session_token,
        r = e.session_jwt,
        n = this._datalayer.readSessionCookie(),
        i = Object.assign(Object.assign({}, n), {
          session_token: t,
          session_jwt: r
        });
      t || r ? (this._datalayer.writeSessionCookie(i), this._datalayer.removeISTCookie()) : this._datalayer.removeSessionCookie();
    }
  }, {
    key: "subscribeToState",
    value: function subscribeToState(e) {
      return function (e, t) {
        var r = Math.random().toString(36).slice(-10);
        return e[r] = t, function () {
          return delete e[r];
        };
      }(this._datalayer.subscriptions, e);
    }
  }, {
    key: "getState",
    value: function getState() {
      return this._datalayer.state;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      window.removeEventListener("storage", this._listen);
    }
  }, {
    key: "syncFromDeviceStorage",
    value: function syncFromDeviceStorage() {
      return null;
    }
  }]);
  return Nt;
}();
var Ut = /*#__PURE__*/function (_Nt) {
  _inherits(Ut, _Nt);
  var _super3 = _createSuper(Ut);
  function Ut() {
    var _this10;
    _classCallCheck(this, Ut);
    _this10 = _super3.apply(this, arguments), _this10.updateUser = function (e) {
      return _this10.updateState({
        user: e
      });
    }, _this10.getUser = function () {
      var e, t;
      return null !== (t = null === (e = _this10.getState()) || void 0 === e ? void 0 : e.user) && void 0 !== t ? t : null;
    }, _this10.getSession = function () {
      var e, t;
      return null !== (t = null === (e = _this10.getState()) || void 0 === e ? void 0 : e.session) && void 0 !== t ? t : null;
    };
    return _this10;
  }
  return _createClass(Ut);
}(Nt);
var Kt = Symbol["for"]("stytch__internal_b2c");
var Wt = /*#__PURE__*/_createClass(function Wt(e, t) {
  var _this11 = this;
  _classCallCheck(this, Wt);
  var r;
  !function (e) {
    var t = "StytchUIClient" === e ? "import { createStytchUIClient } from '@stytch/nextjs/ui';\n    \nconst stytch = createStytchUIClient('public-token-...');\n" : "import { createStytchHeadlessClient } from '@stytch/nextjs/ui';\n    \nconst stytch = createStytchHeadlessClient('public-token-...');\n";
    if ("undefined" == typeof window) throw new Error("The ".concat(e, " is not compatible with server-side environments.\nIf using nextjs, use the create").concat(e, " method instead.\n```\n").concat(t, "\n```\n"));
  }("StytchHeadlessClient"), "string" != typeof (r = e) ? Q("Public token is malformed. Expected a string, got ".concat(i(r), ".").concat(te)) : "" === r ? Q('Public token is malformed. Expected "public-token-...", got an empty string.'.concat(te)) : r.startsWith("public-token-") || Q('Public token is malformed. Expected "public-token-...", got '.concat(r, ".").concat(te));
  var n = t,
    s = {
      cookieOptions: null == (o = n) ? void 0 : o.cookieOptions,
      endpoints: {
        sdkBackendURL: null !== (c = null === (a = null == o ? void 0 : o.endpoints) || void 0 === a ? void 0 : a.sdkBackendURL) && void 0 !== c ? c : "https://web.stytch.com",
        testAPIURL: null !== (l = null === (u = null == o ? void 0 : o.endpoints) || void 0 === u ? void 0 : u.testAPIURL) && void 0 !== l ? l : "https://test.stytch.com",
        liveAPIURL: null !== (h = null === (d = null == o ? void 0 : o.endpoints) || void 0 === d ? void 0 : d.liveAPIURL) && void 0 !== h ? h : "https://api.stytch.com",
        dfpBackendURL: null !== (f = null === (p = null == o ? void 0 : o.endpoints) || void 0 === p ? void 0 : p.dfpBackendURL) && void 0 !== f ? f : "https://telemetry.stytch.com",
        clientsideServicesIframeURL: null !== (m = null === (_ = null == o ? void 0 : o.endpoints) || void 0 === _ ? void 0 : _.clientsideServicesIframeURL) && void 0 !== m ? m : "https://js.stytch.com/clientside-services/index.html"
      }
    };
  var o, a, c, u, l, d, h, p, f, _, m;
  this._dataLayer = Ft(e, n), this._subscriptionService = new Ut(e, this._dataLayer);
  var v = new Ot(this._dataLayer, "passwords");
  this._networkClient = new St(e, this._dataLayer, s.endpoints.sdkBackendURL, function () {
    var e, t, r, n;
    return {
      stytch_user_id: null === (t = null === (e = _this11._dataLayer.state) || void 0 === e ? void 0 : e.user) || void 0 === t ? void 0 : t.user_id,
      stytch_session_id: null === (n = null === (r = _this11._dataLayer.state) || void 0 === r ? void 0 : r.session) || void 0 === n ? void 0 : n.session_id
    };
  });
  var y = new Ge(e, this._networkClient, this._dataLayer),
    g = new Ye(y.getAsync()),
    b = new se(e, s.endpoints.dfpBackendURL, y.getAsync(), g.executeRecaptcha),
    k = new ze(s.endpoints.clientsideServicesIframeURL),
    w = new At(e, k),
    S = new Et(this._networkClient);
  var C, A;
  this.user = new ue(this._networkClient, this._subscriptionService), this.session = new le(this._networkClient, this._subscriptionService), this.magicLinks = new he(this._networkClient, this._subscriptionService, new Ot(this._dataLayer, "magic_links"), v, y.getAsync(), b), this.otps = new pe(this._networkClient, this._subscriptionService, g.executeRecaptcha, b), this.oauth = new wt(this._networkClient, this._subscriptionService, new Ot(this._dataLayer, "oauth"), y.getAsync(), {
    publicToken: e,
    testAPIURL: s.endpoints.testAPIURL,
    liveAPIURL: s.endpoints.liveAPIURL
  }, w), this.cryptoWallets = new _e(this._networkClient, this._subscriptionService, g.executeRecaptcha, b), this.totps = new me(this._networkClient, this._subscriptionService, b), this.webauthn = new Me(this._networkClient, this._subscriptionService, b), this.passwords = new Ue(this._networkClient, this._subscriptionService, v, y.getAsync(), b), this._sessionManager = new We(this._subscriptionService, this.session), this._dataLayer.readSessionCookie().session_token && this._sessionManager.performBackgroundRefresh(), this._networkClient.logEvent({
    name: "sdk_instance_instantiated",
    details: {
      event_callback_registered: !1,
      error_callback_registered: !1,
      success_callback_registered: !1
    }
  }), C = this, A = {
    bootstrap: y,
    clientsideServices: k,
    captcha: g,
    oneTap: w,
    searchManager: S,
    publicToken: e,
    dataLayer: this._dataLayer,
    networkClient: this._networkClient
  }, Object.assign(C, _defineProperty({}, Kt, A));
});
export { ft as AuthFlowType, _t as B2BOAuthProviders, pt as B2BProducts, ht as BiometricsErrors, at as OAuthProviders, lt as OTPMethods, ut as OneTapPositions, ot as Products, mt as SDKAPIUnreachableError, dt as StytchEventType, Wt as StytchHeadlessClient, gt as StytchSDKAPIError, bt as StytchSDKNativeError, yt as StytchSDKSchemaError, vt as StytchSDKUsageError, kt as UNRECOVERABLE_ERROR_TYPES, ct as Wallets };
